
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */
// biome-ignore-all lint: generated file

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.19.0
 * Query Engine version: 2ba551f319ab1df4bc874a89965d8b3641056773
 */
Prisma.prismaVersion = {
  client: "6.19.0",
  engine: "2ba551f319ab1df4bc874a89965d8b3641056773"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AiUsageTrackingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  provider: 'provider',
  model: 'model',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  cachedInputTokens: 'cachedInputTokens',
  totalTokens: 'totalTokens',
  estimatedCost: 'estimatedCost',
  tenantId: 'tenantId',
  documentId: 'documentId',
  userId: 'userId',
  operation: 'operation',
  duration: 'duration',
  metadata: 'metadata'
};

exports.Prisma.RelationLoadStrategy = {
  query: 'query',
  join: 'join'
};

exports.Prisma.AuditScalarFieldEnum = {
  auditId: 'auditId',
  recordId: 'recordId',
  operation: 'operation',
  timestamp: 'timestamp',
  user: 'user',
  session: 'session',
  tableOid: 'tableOid',
  tableSchema: 'tableSchema',
  tableName: 'tableName',
  record: 'record',
  oldRecord: 'oldRecord'
};

exports.Prisma.AuditedTableScalarFieldEnum = {
  id: 'id',
  tableName: 'tableName',
  shouldAudit: 'shouldAudit',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ChemicalScalarFieldEnum = {
  id: 'id',
  needsReview: 'needsReview',
  name: 'name',
  casNumber: 'casNumber',
  normalizedCasNumber: 'normalizedCasNumber',
  noCasNumber: 'noCasNumber',
  alternateId: 'alternateId',
  isEhs: 'isEhs',
  pureOrMixture: 'pureOrMixture',
  stateOfMatter: 'stateOfMatter',
  isTradeSecret: 'isTradeSecret',
  density: 'density',
  densityUnits: 'densityUnits',
  manufacturerSupplier: 'manufacturerSupplier',
  recommendedUse: 'recommendedUse',
  version: 'version',
  revisionDate: 'revisionDate',
  physicalHazards: 'physicalHazards',
  healthHazards: 'healthHazards',
  oregonHazards: 'oregonHazards',
  ifcHazards: 'ifcHazards',
  noHazardsNotReporting: 'noHazardsNotReporting',
  ehsForm: 'ehsForm',
  createdAtViaMerge: 'createdAtViaMerge',
  verifiedAt: 'verifiedAt',
  verifiedBy: 'verifiedBy',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ChemicalComponentScalarFieldEnum = {
  id: 'id',
  chemicalId: 'chemicalId',
  name: 'name',
  casNumber: 'casNumber',
  normalizedCasNumber: 'normalizedCasNumber',
  noCasNumber: 'noCasNumber',
  isEhs: 'isEhs',
  componentPercentage: 'componentPercentage',
  weightOrVolume: 'weightOrVolume',
  ehsForm: 'ehsForm',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ChemicalDocumentScalarFieldEnum = {
  id: 'id',
  key: 'key',
  name: 'name',
  documentId: 'documentId',
  chemicalId: 'chemicalId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ChemicalMapScalarFieldEnum = {
  id: 'id',
  state: 'state',
  chemicalId: 'chemicalId',
  encampName: 'encampName',
  encampCasNumber: 'encampCasNumber',
  mappedName: 'mappedName',
  mappedCasNumber: 'mappedCasNumber',
  mappedEhs: 'mappedEhs',
  tenantName: 'tenantName',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ChemicalStateFieldScalarFieldEnum = {
  id: 'id',
  chemicalId: 'chemicalId',
  key: 'key',
  value: 'value',
  type: 'type',
  jurisdiction: 'jurisdiction',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ChemicalTenantScalarFieldEnum = {
  id: 'id',
  chemicalId: 'chemicalId',
  tenantId: 'tenantId'
};

exports.Prisma.CohortScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  reportingYear: 'reportingYear',
  type: 'type',
  status: 'status',
  errorMessage: 'errorMessage',
  currentWorkflowId: 'currentWorkflowId',
  fdId: 'fdId',
  lepcId: 'lepcId',
  credentialUsername: 'credentialUsername',
  alternateIdValue: 'alternateIdValue',
  state: 'state',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CohortMemberScalarFieldEnum = {
  id: 'id',
  cohortId: 'cohortId',
  facilityId: 'facilityId',
  tierIIReportId: 'tierIIReportId',
  status: 'status',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  reportId: 'reportId',
  userId: 'userId',
  isSystemMessage: 'isSystemMessage',
  workflowId: 'workflowId',
  activityId: 'activityId',
  submissionId: 'submissionId',
  comment: 'comment',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CommunicationScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  lepcId: 'lepcId',
  fireDepartmentId: 'fireDepartmentId',
  policeDepartmentId: 'policeDepartmentId',
  leadAgencyId: 'leadAgencyId',
  activityId: 'activityId',
  recipientName: 'recipientName',
  proofDocumentId: 'proofDocumentId',
  communicationType: 'communicationType',
  status: 'status',
  generateCoverLetter: 'generateCoverLetter',
  lobMailId: 'lobMailId',
  jobId: 'jobId',
  sendGridEmailId: 'sendGridEmailId',
  trackingId: 'trackingId',
  emailRecipientAddresses: 'emailRecipientAddresses',
  emailSubject: 'emailSubject',
  emailFrom: 'emailFrom',
  emailReplyTo: 'emailReplyTo',
  emailTemplateName: 'emailTemplateName',
  emailBody: 'emailBody',
  mailRecipientAddressLine1: 'mailRecipientAddressLine1',
  mailRecipientAddressLine2: 'mailRecipientAddressLine2',
  mailRecipientCity: 'mailRecipientCity',
  mailRecipientState: 'mailRecipientState',
  mailRecipientZip: 'mailRecipientZip',
  completedByUserId: 'completedByUserId',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CommunicationDocumentScalarFieldEnum = {
  id: 'id',
  communicationId: 'communicationId',
  documentId: 'documentId',
  sequence: 'sequence',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CommunicationFacilityScalarFieldEnum = {
  id: 'id',
  communicationId: 'communicationId',
  facilityId: 'facilityId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.LobAddressScalarFieldEnum = {
  id: 'id',
  recipient: 'recipient',
  primaryLine: 'primaryLine',
  secondaryLine: 'secondaryLine',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.LobMailScalarFieldEnum = {
  id: 'id',
  lobId: 'lobId',
  type: 'type',
  status: 'status',
  lobUrl: 'lobUrl',
  data: 'data',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SendGridEmailScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  to: 'to',
  from: 'from',
  replyTo: 'replyTo',
  subject: 'subject',
  templateId: 'templateId',
  sendDate: 'sendDate'
};

exports.Prisma.ComplianceQuarterScalarFieldEnum = {
  quarter: 'quarter',
  cwaIndex: 'cwaIndex',
  caaIndex: 'caaIndex',
  rcraIndex: 'rcraIndex',
  overallIndex: 'overallIndex'
};

exports.Prisma.AlternateIdCredentialScalarFieldEnum = {
  id: 'id',
  credentialId: 'credentialId',
  alternateIdValue: 'alternateIdValue',
  alternateIdType: 'alternateIdType',
  alternateIdMetadata: 'alternateIdMetadata',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.AlternateIdInfoScalarFieldEnum = {
  id: 'id',
  alternateIdType: 'alternateIdType',
  alternateIdValue: 'alternateIdValue',
  tenantId: 'tenantId',
  description: 'description',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CredentialScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  isEncampOwned: 'isEncampOwned',
  name: 'name',
  username: 'username',
  password: 'password',
  email: 'email',
  kind: 'kind',
  securityQuestions: 'securityQuestions',
  verificationStatus: 'verificationStatus',
  lastVerificationSuccessAt: 'lastVerificationSuccessAt',
  lastVerificationCheckAt: 'lastVerificationCheckAt',
  onePasswordId: 'onePasswordId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  usesCombinedInvoicing: 'usesCombinedInvoicing',
  usesRcoCredential: 'usesRcoCredential'
};

exports.Prisma.CredentialUsageLogScalarFieldEnum = {
  id: 'id',
  credentialId: 'credentialId',
  jobId: 'jobId',
  verificationStatus: 'verificationStatus',
  errorMessage: 'errorMessage',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.OneTimePasswordScalarFieldEnum = {
  id: 'id',
  credentialId: 'credentialId',
  jobId: 'jobId',
  otpCode: 'otpCode',
  emailSentDate: 'emailSentDate',
  conversationId: 'conversationId',
  messageId: 'messageId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.DataLedgerScalarFieldEnum = {
  id: 'id',
  source: 'source',
  target: 'target',
  action: 'action',
  tenantId: 'tenantId',
  tenantName: 'tenantName',
  reportingYear: 'reportingYear',
  user: 'user',
  sessionId: 'sessionId',
  options: 'options',
  performedAt: 'performedAt'
};

exports.Prisma.DocumentScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  title: 'title',
  description: 'description',
  fileExtension: 'fileExtension',
  state: 'state',
  area: 'area',
  documentType: 'documentType',
  storageLink: 'storageLink',
  sizeMegabytes: 'sizeMegabytes',
  lobId: 'lobId',
  originalTitle: 'originalTitle',
  originalDocumentType: 'originalDocumentType',
  isArchived: 'isArchived',
  authoredAt: 'authoredAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  extractionStatus: 'extractionStatus',
  lastExtractionAt: 'lastExtractionAt',
  extractionError: 'extractionError'
};

exports.Prisma.DocumentMetadataScalarFieldEnum = {
  id: 'id',
  documentId: 'documentId',
  type: 'type',
  documentType: 'documentType',
  documentSubtype: 'documentSubtype',
  documentNumber: 'documentNumber',
  relatedDocumentNumber: 'relatedDocumentNumber',
  revisionNumber: 'revisionNumber',
  reportingPeriod: 'reportingPeriod',
  siteName: 'siteName',
  siteAddressLine1: 'siteAddressLine1',
  siteAddressLine2: 'siteAddressLine2',
  siteCity: 'siteCity',
  siteState: 'siteState',
  siteZipCode: 'siteZipCode',
  siteEmail: 'siteEmail',
  mailingName: 'mailingName',
  mailingAddressLine1: 'mailingAddressLine1',
  mailingAddressLine2: 'mailingAddressLine2',
  mailingCity: 'mailingCity',
  mailingState: 'mailingState',
  mailingZipCode: 'mailingZipCode',
  mailingEmail: 'mailingEmail',
  contactName: 'contactName',
  contactEmail: 'contactEmail',
  contactPhone: 'contactPhone',
  contactAddressLine1: 'contactAddressLine1',
  contactAddressLine2: 'contactAddressLine2',
  contactCity: 'contactCity',
  contactState: 'contactState',
  contactZipCode: 'contactZipCode',
  agency: 'agency',
  programArea: 'programArea',
  regulatoryProgram: 'regulatoryProgram',
  regulatoryCitations: 'regulatoryCitations',
  regulatoryAuthority: 'regulatoryAuthority',
  issueDate: 'issueDate',
  expirationDate: 'expirationDate',
  effectiveDate: 'effectiveDate',
  submissionDeadline: 'submissionDeadline',
  dueDate: 'dueDate',
  amount: 'amount',
  currency: 'currency',
  lineItems: 'lineItems',
  relatedDocumentIds: 'relatedDocumentIds',
  supersedes: 'supersedes',
  summary: 'summary',
  keywords: 'keywords',
  embeddingModel: 'embeddingModel',
  embeddingCreatedAt: 'embeddingCreatedAt',
  needsReview: 'needsReview',
  reviewedAt: 'reviewedAt',
  reviewedBy: 'reviewedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DocumentTagScalarFieldEnum = {
  id: 'id',
  tagId: 'tagId',
  documentId: 'documentId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.EManifestSiteSyncScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  maxManifestUpdatedDate: 'maxManifestUpdatedDate',
  lastPermissionsErrorAt: 'lastPermissionsErrorAt',
  hasSiteAccess: 'hasSiteAccess',
  syncedAt: 'syncedAt'
};

exports.Prisma.EmulatedRoleScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  userId: 'userId',
  tenantId: 'tenantId',
  roleId: 'roleId',
  permissions: 'permissions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt'
};

exports.Prisma.ErrorClusterScalarFieldEnum = {
  id: 'id',
  workflowType: 'workflowType',
  runId: 'runId',
  groupId: 'groupId',
  tenantId: 'tenantId',
  reportId: 'reportId',
  facilityId: 'facilityId',
  workflowId: 'workflowId',
  activityId: 'activityId',
  tenantName: 'tenantName',
  facilityName: 'facilityName',
  state: 'state',
  activityType: 'activityType',
  activityDescription: 'activityDescription',
  errorMessage: 'errorMessage',
  reportTags: 'reportTags',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CalculatedRegulatoryStatusScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  periodStart: 'periodStart',
  source: 'source',
  federalStatus: 'federalStatus',
  stateStatus: 'stateStatus',
  determinationFactors: 'determinationFactors',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.CalculationOperationScalarFieldEnum = {
  id: 'id',
  reportingFacilityChemicalId: 'reportingFacilityChemicalId',
  operation: 'operation',
  createdAt: 'createdAt'
};

exports.Prisma.FacilityScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  name: 'name',
  status: 'status',
  statusReason: 'statusReason',
  businessUnit: 'businessUnit',
  customerFacilityId: 'customerFacilityId',
  dbNumber: 'dbNumber',
  facilityType: 'facilityType',
  naicsCode: 'naicsCode',
  maxNumOccupants: 'maxNumOccupants',
  isUnmanned: 'isUnmanned',
  phone: 'phone',
  phone24Hour: 'phone24Hour',
  streetAddress1: 'streetAddress1',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  country: 'country',
  mailingCompanyName: 'mailingCompanyName',
  mailingStreetAddress1: 'mailingStreetAddress1',
  mailingStreetAddress2: 'mailingStreetAddress2',
  mailingCity: 'mailingCity',
  mailingState: 'mailingState',
  mailingZip: 'mailingZip',
  mailingCountry: 'mailingCountry',
  isMailingAddressSameAsFacility: 'isMailingAddressSameAsFacility',
  isMailingAddressEncamp: 'isMailingAddressEncamp',
  county: 'county',
  municipality: 'municipality',
  latitude: 'latitude',
  longitude: 'longitude',
  isAutoGeocoded: 'isAutoGeocoded',
  dateOpened: 'dateOpened',
  dateClosed: 'dateClosed',
  dateInactive: 'dateInactive',
  lastProductMeasuredAt: 'lastProductMeasuredAt',
  streetAddressVerifiedAt: 'streetAddressVerifiedAt',
  isSubjectToEmergencyPlanning: 'isSubjectToEmergencyPlanning',
  isSubjectToEmergencyPlanningInternal: 'isSubjectToEmergencyPlanningInternal',
  isSubjectToChemicalAccidentPrevention: 'isSubjectToChemicalAccidentPrevention',
  isSubjectToToxicsReleaseInventoryReporting: 'isSubjectToToxicsReleaseInventoryReporting',
  collectionMode: 'collectionMode',
  companyName: 'companyName',
  department: 'department',
  isInactive: 'isInactive',
  isClosed: 'isClosed',
  colocationReportingFacilityId: 'colocationReportingFacilityId',
  isNotReporting: 'isNotReporting',
  isNotReportingThroughEncamp: 'isNotReportingThroughEncamp',
  chemicalFeatureFlagOverride: 'chemicalFeatureFlagOverride',
  wasteFeatureFlagOverride: 'wasteFeatureFlagOverride',
  reportsManually: 'reportsManually',
  useEncampBillingContact: 'useEncampBillingContact',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  fireDepartmentId: 'fireDepartmentId',
  lepcId: 'lepcId',
  fireDepartmentName: 'fireDepartmentName',
  lepcName: 'lepcName',
  embeddingModel: 'embeddingModel',
  embeddingCreatedAt: 'embeddingCreatedAt'
};

exports.Prisma.FacilityAlternateIdScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  value: 'value',
  hasNoId: 'hasNoId',
  type: 'type',
  expiresAt: 'expiresAt',
  tenantId: 'tenantId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityChemicalScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  chemicalId: 'chemicalId',
  reportingYear: 'reportingYear',
  maxAmount: 'maxAmount',
  maxAmountCode: 'maxAmountCode',
  averageAmount: 'averageAmount',
  averageAmountCode: 'averageAmountCode',
  maxAmountLargestContainer: 'maxAmountLargestContainer',
  daysOnSite: 'daysOnSite',
  hasConfidentialStorageLocations: 'hasConfidentialStorageLocations',
  unit: 'unit',
  isAlwaysReported: 'isAlwaysReported',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityChemicalMeasurementScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  chemicalId: 'chemicalId',
  storageLocationId: 'storageLocationId',
  amount: 'amount',
  unit: 'unit',
  measuredAtUtc: 'measuredAtUtc',
  endDate: 'endDate',
  storageType: 'storageType',
  storageTypeDescription: 'storageTypeDescription',
  pressure: 'pressure',
  temperature: 'temperature',
  otherPressureValue: 'otherPressureValue',
  maxAmountLargestContainer: 'maxAmountLargestContainer',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityChemicalStateFieldScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  chemicalId: 'chemicalId',
  reportingYear: 'reportingYear',
  key: 'key',
  value: 'value',
  type: 'type',
  jurisdiction: 'jurisdiction',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityChemicalStorageLocationScalarFieldEnum = {
  id: 'id',
  facilityChemicalId: 'facilityChemicalId',
  storageLocationId: 'storageLocationId',
  storageType: 'storageType',
  storageTypeDescription: 'storageTypeDescription',
  pressure: 'pressure',
  temperature: 'temperature',
  maxAmount: 'maxAmount',
  unit: 'unit',
  otherPressureValue: 'otherPressureValue',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityContactScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  personId: 'personId',
  reportingRoles: 'reportingRoles',
  isPrimaryContact: 'isPrimaryContact',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityCredentialScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  credentialId: 'credentialId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityDocumentScalarFieldEnum = {
  id: 'id',
  documentId: 'documentId',
  facilityId: 'facilityId',
  currentSubmissionDocument: 'currentSubmissionDocument',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityPaymentScalarFieldEnum = {
  paymentId: 'paymentId',
  facilityId: 'facilityId',
  amount: 'amount'
};

exports.Prisma.FacilityPilotProgramScalarFieldEnum = {
  id: 'id',
  state: 'state',
  reportingYear: 'reportingYear',
  status: 'status',
  notes: 'notes',
  documentationComplete: 'documentationComplete',
  qaComplete: 'qaComplete',
  createdAt: 'createdAt',
  createdBy: 'createdBy'
};

exports.Prisma.FacilityProductScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  productId: 'productId',
  reportingYear: 'reportingYear',
  maxQuantity: 'maxQuantity',
  averageQuantity: 'averageQuantity',
  daysOnSite: 'daysOnSite',
  hasConfidentialStorageLocations: 'hasConfidentialStorageLocations',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityProductMeasurementScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  productId: 'productId',
  storageLocationId: 'storageLocationId',
  measuredAtUtc: 'measuredAtUtc',
  endDate: 'endDate',
  quantity: 'quantity',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityProductStorageLocationScalarFieldEnum = {
  id: 'id',
  facilityProductId: 'facilityProductId',
  storageLocationId: 'storageLocationId',
  maxQuantity: 'maxQuantity',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityStateFieldScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  key: 'key',
  value: 'value',
  type: 'type',
  jurisdiction: 'jurisdiction',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityTagScalarFieldEnum = {
  id: 'id',
  tagId: 'tagId',
  facilityId: 'facilityId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ProcessedManifestScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  manifestTrackingNumber: 'manifestTrackingNumber',
  eManifestId: 'eManifestId',
  vendorManifestId: 'vendorManifestId',
  hasIssues: 'hasIssues',
  hasIssuesReason: 'hasIssuesReason',
  shippedDate: 'shippedDate',
  epaId: 'epaId',
  destinationFacilityId: 'destinationFacilityId',
  destinationFacilityName: 'destinationFacilityName',
  receivedDate: 'receivedDate',
  vendorSource: 'vendorSource',
  eManifestCreatedDate: 'eManifestCreatedDate',
  eManifestCertifiedDate: 'eManifestCertifiedDate',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ReportingFacilityChemicalScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  chemicalId: 'chemicalId',
  reportingYear: 'reportingYear',
  maxAmount: 'maxAmount',
  maxAmountCode: 'maxAmountCode',
  averageAmount: 'averageAmount',
  averageAmountCode: 'averageAmountCode',
  maxAmountLargestContainer: 'maxAmountLargestContainer',
  daysOnSite: 'daysOnSite',
  hasConfidentialStorageLocations: 'hasConfidentialStorageLocations',
  unit: 'unit',
  isAlwaysReported: 'isAlwaysReported',
  isOverThreshold: 'isOverThreshold',
  thresholdReason: 'thresholdReason',
  manuallyEdited: 'manuallyEdited',
  aggregationErrorMessage: 'aggregationErrorMessage',
  aggregationError: 'aggregationError',
  dailyAmount: 'dailyAmount',
  dailyMaxAmountLargestContainer: 'dailyMaxAmountLargestContainer',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ReportingFacilityChemicalOriginScalarFieldEnum = {
  id: 'id',
  reportingFacilityChemicalId: 'reportingFacilityChemicalId',
  facilityChemicalId: 'facilityChemicalId'
};

exports.Prisma.ReportingFacilityChemicalStorageLocationScalarFieldEnum = {
  id: 'id',
  reportingFacilityChemicalId: 'reportingFacilityChemicalId',
  storageLocationId: 'storageLocationId',
  maxAmount: 'maxAmount',
  unit: 'unit',
  storageType: 'storageType',
  storageTypeDescription: 'storageTypeDescription',
  pressure: 'pressure',
  temperature: 'temperature',
  insideOutside: 'insideOutside',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ReportingFacilityChemicalThresholdResultScalarFieldEnum = {
  id: 'id',
  reportingFacilityChemicalId: 'reportingFacilityChemicalId',
  thresholdResultId: 'thresholdResultId',
  facilityId: 'facilityId',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.ThresholdResultScalarFieldEnum = {
  id: 'id',
  threshold: 'threshold',
  unit: 'unit',
  jurisdiction: 'jurisdiction',
  description: 'description',
  overThreshold: 'overThreshold',
  isSection312: 'isSection312',
  isSection302: 'isSection302',
  type: 'type',
  casNumber: 'casNumber',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FireDepartmentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  state: 'state',
  city: 'city',
  county: 'county',
  zip: 'zip',
  mailingAddress: 'mailingAddress',
  mailingAddressLine2: 'mailingAddressLine2',
  phone: 'phone',
  phoneExt: 'phoneExt',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  title: 'title',
  latitude: 'latitude',
  longitude: 'longitude',
  additionalComments: 'additionalComments',
  stateSubmitsToFireDept: 'stateSubmitsToFireDept',
  needsT2sFile: 'needsT2sFile',
  isMailed: 'isMailed',
  isEmailed: 'isEmailed',
  portalId: 'portalId',
  portalName: 'portalName',
  preferUncertified: 'preferUncertified',
  isSubmittedViaPortal: 'isSubmittedViaPortal',
  deactivated: 'deactivated',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.EchoAirFacilityScalarFieldEnum = {
  pgmSysId: 'pgmSysId',
  registryId: 'registryId',
  facilityName: 'facilityName',
  streetAddress: 'streetAddress',
  city: 'city',
  countyName: 'countyName',
  state: 'state',
  zipCode: 'zipCode',
  epaRegion: 'epaRegion',
  sicCodes: 'sicCodes',
  naicsCodes: 'naicsCodes',
  facilityTypeCode: 'facilityTypeCode',
  airPollutantClassCode: 'airPollutantClassCode',
  airPollutantClassDesc: 'airPollutantClassDesc',
  airOperatingStatusCode: 'airOperatingStatusCode',
  airOperatingStatusDesc: 'airOperatingStatusDesc',
  currentHpv: 'currentHpv',
  localControlRegionCode: 'localControlRegionCode',
  localControlRegionName: 'localControlRegionName'
};

exports.Prisma.EchoAirViolationHistoryScalarFieldEnum = {
  pgmSysId: 'pgmSysId',
  activityId: 'activityId',
  agencyTypeDesc: 'agencyTypeDesc',
  stateCode: 'stateCode',
  airLconCode: 'airLconCode',
  compDeterminationUid: 'compDeterminationUid',
  enfResponsePolicyCode: 'enfResponsePolicyCode',
  programCodes: 'programCodes',
  programDescs: 'programDescs',
  pollutantCodes: 'pollutantCodes',
  pollutantDescs: 'pollutantDescs',
  earliestFrvDetermDate: 'earliestFrvDetermDate',
  hpvDayzeroDate: 'hpvDayzeroDate',
  hpvResolvedDate: 'hpvResolvedDate',
  dscvPathwayDate: 'dscvPathwayDate',
  nftcPathwayDate: 'nftcPathwayDate'
};

exports.Prisma.CaseEnforcementsScalarFieldEnum = {
  activityId: 'activityId',
  activityName: 'activityName',
  stateCode: 'stateCode',
  regionCode: 'regionCode',
  fiscalYear: 'fiscalYear',
  caseNumber: 'caseNumber',
  caseName: 'caseName',
  activityTypeCode: 'activityTypeCode',
  activityTypeDesc: 'activityTypeDesc',
  activityStatusCode: 'activityStatusCode',
  activityStatusDesc: 'activityStatusDesc',
  activityStatusDate: 'activityStatusDate',
  lead: 'lead',
  caseStatusDate: 'caseStatusDate',
  dojDocketNmbr: 'dojDocketNmbr',
  enfOutcomeCode: 'enfOutcomeCode',
  enfOutcomeDesc: 'enfOutcomeDesc',
  totalPenaltyAssessedAmt: 'totalPenaltyAssessedAmt',
  totalCostRecoveryAmt: 'totalCostRecoveryAmt',
  totalCompActionAmt: 'totalCompActionAmt',
  hqDivision: 'hqDivision',
  branch: 'branch',
  voluntarySelfDisclosureFlag: 'voluntarySelfDisclosureFlag',
  multimediaFlag: 'multimediaFlag',
  enfSummaryText: 'enfSummaryText'
};

exports.Prisma.CaseProgramsScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  programCode: 'programCode',
  programDesc: 'programDesc'
};

exports.Prisma.CaseEnforcementConclusionsScalarFieldEnum = {
  enfConclusionId: 'enfConclusionId',
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  enfConclusionNmbr: 'enfConclusionNmbr',
  enfConclusionActionCode: 'enfConclusionActionCode',
  enfConclusionName: 'enfConclusionName',
  settlementLodgedDate: 'settlementLodgedDate',
  settlementEnteredDate: 'settlementEnteredDate',
  settlementFy: 'settlementFy',
  primaryLaw: 'primaryLaw',
  regionCode: 'regionCode',
  activityTypeCode: 'activityTypeCode',
  fedPenaltyAssessedAmt: 'fedPenaltyAssessedAmt',
  stateLocalPenaltyAmt: 'stateLocalPenaltyAmt',
  sepAmt: 'sepAmt',
  complianceActionCost: 'complianceActionCost',
  costRecoveryAwardedAmt: 'costRecoveryAwardedAmt'
};

exports.Prisma.CaseEnforcementTypeScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  enfTypeCode: 'enfTypeCode',
  enfTypeDesc: 'enfTypeDesc'
};

exports.Prisma.CasePrioritiesScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  priorityCode: 'priorityCode',
  priorityDesc: 'priorityDesc',
  fiscalYear: 'fiscalYear'
};

exports.Prisma.CasePollutantsScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  pollutantCode: 'pollutantCode',
  pollutantDesc: 'pollutantDesc',
  chemicalAbstractServiceNmbr: 'chemicalAbstractServiceNmbr'
};

exports.Prisma.CaseLawSectionsScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  rankOrder: 'rankOrder',
  statuteCode: 'statuteCode',
  lawSectionCode: 'lawSectionCode',
  lawSectionDesc: 'lawSectionDesc',
  echoDesc: 'echoDesc'
};

exports.Prisma.CaseViolationsScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  violationTypeCode: 'violationTypeCode',
  rankOrder: 'rankOrder',
  violationTypeDesc: 'violationTypeDesc'
};

exports.Prisma.CaseEnforcementConclusionPollutantsScalarFieldEnum = {
  environmentalImpactId: 'environmentalImpactId',
  enfConclusionId: 'enfConclusionId',
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  compActionId: 'compActionId',
  sepId: 'sepId',
  pollutantCode: 'pollutantCode',
  pollutantName: 'pollutantName',
  averageAnnualValue: 'averageAnnualValue',
  pollutantUnitCode: 'pollutantUnitCode',
  mediaCode: 'mediaCode',
  mediaDesc: 'mediaDesc',
  sepOrCompFlag: 'sepOrCompFlag'
};

exports.Prisma.EpaInformalEnforcementActionsScalarFieldEnum = {
  pgmSysAcrnm: 'pgmSysAcrnm',
  pgmSysId: 'pgmSysId',
  registryId: 'registryId',
  agency: 'agency',
  activityTypeCode: 'activityTypeCode',
  enfTypeCode: 'enfTypeCode',
  enfTypeDesc: 'enfTypeDesc',
  achievedDate: 'achievedDate',
  enfIdentifier: 'enfIdentifier',
  statute: 'statute'
};

exports.Prisma.CasePenaltiesScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  fedPenalty: 'fedPenalty',
  stLclPenalty: 'stLclPenalty',
  totalSep: 'totalSep',
  complianceActionCost: 'complianceActionCost',
  federalCostRecoveryAmt: 'federalCostRecoveryAmt',
  stateLocalCostRecoveryAmt: 'stateLocalCostRecoveryAmt',
  penaltyCollectedAmt: 'penaltyCollectedAmt'
};

exports.Prisma.CaseFacilitiesScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  registryId: 'registryId',
  facilityName: 'facilityName',
  locationAddress: 'locationAddress',
  city: 'city',
  stateCode: 'stateCode',
  zip: 'zip',
  primarySicCode: 'primarySicCode',
  primaryNaicsCode: 'primaryNaicsCode'
};

exports.Prisma.CaseDefendantsScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  defendantName: 'defendantName',
  namedInComplaintFlag: 'namedInComplaintFlag',
  namedInSettlementFlag: 'namedInSettlementFlag'
};

exports.Prisma.CaseRelatedActivitiesScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  activityStatusDate: 'activityStatusDate',
  activityTypeCode: 'activityTypeCode',
  activityTypeDesc: 'activityTypeDesc'
};

exports.Prisma.CaseEnforcementConclusionFacilitiesScalarFieldEnum = {
  enfConclusionId: 'enfConclusionId',
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  icisFacilityInterestId: 'icisFacilityInterestId',
  facilityUin: 'facilityUin',
  facilityName: 'facilityName',
  facilityCity: 'facilityCity',
  facilityState: 'facilityState',
  facilityZip: 'facilityZip'
};

exports.Prisma.CaseEnforcementConclusionDollarsScalarFieldEnum = {
  enfConclusionId: 'enfConclusionId',
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  stateLocalPenaltyAmt: 'stateLocalPenaltyAmt',
  costRecoveryAmt: 'costRecoveryAmt',
  fedPenalty: 'fedPenalty',
  complianceActionCost: 'complianceActionCost',
  sepCost: 'sepCost',
  penaltyCollectedAmt: 'penaltyCollectedAmt'
};

exports.Prisma.IcisFecEpaInspectionsScalarFieldEnum = {
  activityId: 'activityId',
  registryId: 'registryId',
  pgmSysAcrnm: 'pgmSysAcrnm',
  pgmSysId: 'pgmSysId',
  facilityName: 'facilityName',
  epaRegionCode: 'epaRegionCode',
  activityTypeCode: 'activityTypeCode',
  activityTypeDesc: 'activityTypeDesc',
  compMonitorUid: 'compMonitorUid',
  compMonitorTypes: 'compMonitorTypes',
  statuteCode: 'statuteCode',
  lawSectionCode: 'lawSectionCode',
  actualBeginDate: 'actualBeginDate',
  actualEndDate: 'actualEndDate',
  agency: 'agency',
  compMonitorAgencyTypes: 'compMonitorAgencyTypes'
};

exports.Prisma.CaseRegionalDocketsScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  regionalDocketNmbr: 'regionalDocketNmbr'
};

exports.Prisma.CaseReliefSoughtScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  reliefCode: 'reliefCode',
  reliefDesc: 'reliefDesc'
};

exports.Prisma.CaseEnforcementConclusionSepScalarFieldEnum = {
  enfConclusionId: 'enfConclusionId',
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  sepCategoryCode: 'sepCategoryCode',
  sepCategoryDesc: 'sepCategoryDesc',
  sepId: 'sepId',
  sepText: 'sepText',
  sepAmt: 'sepAmt'
};

exports.Prisma.CaseEnforcementConclusionComplyingActionsScalarFieldEnum = {
  compActionId: 'compActionId',
  enfConclusionId: 'enfConclusionId',
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  compActionDescription: 'compActionDescription',
  compActionTypeCode: 'compActionTypeCode',
  compActionTypeDesc: 'compActionTypeDesc',
  compActionCategoryTypeDesc: 'compActionCategoryTypeDesc'
};

exports.Prisma.CaseMilestonesScalarFieldEnum = {
  activityId: 'activityId',
  caseNumber: 'caseNumber',
  subActivityTypeCode: 'subActivityTypeCode',
  subActivityTypeDesc: 'subActivityTypeDesc',
  actualDate: 'actualDate'
};

exports.Prisma.EchoExporterScalarFieldEnum = {
  registryId: 'registryId',
  facName: 'facName',
  facStreet: 'facStreet',
  facCity: 'facCity',
  facState: 'facState',
  facZip: 'facZip',
  facCounty: 'facCounty',
  facFipsCode: 'facFipsCode',
  facEpaRegion: 'facEpaRegion',
  facIndianCntryFlg: 'facIndianCntryFlg',
  facFederalFlg: 'facFederalFlg',
  facUsMexBorderFlg: 'facUsMexBorderFlg',
  facChesapeakeBayFlg: 'facChesapeakeBayFlg',
  facNaaFlag: 'facNaaFlag',
  facLat: 'facLat',
  facLong: 'facLong',
  facMapIcon: 'facMapIcon',
  facCollectionMethod: 'facCollectionMethod',
  facReferencePoint: 'facReferencePoint',
  facAccuracyMeters: 'facAccuracyMeters',
  facDerivedTribes: 'facDerivedTribes',
  facDerivedHuc: 'facDerivedHuc',
  facDerivedWbd: 'facDerivedWbd',
  facDerivedStctyFips: 'facDerivedStctyFips',
  facDerivedZip: 'facDerivedZip',
  facDerivedCd113: 'facDerivedCd113',
  facDerivedCb2010: 'facDerivedCb2010',
  facPercentMinority: 'facPercentMinority',
  facPopDen: 'facPopDen',
  facMajorFlag: 'facMajorFlag',
  facActiveFlag: 'facActiveFlag',
  facMyrtkUniverse: 'facMyrtkUniverse',
  facInspectionCount: 'facInspectionCount',
  facDateLastInspection: 'facDateLastInspection',
  facDaysLastInspection: 'facDaysLastInspection',
  facInformalCount: 'facInformalCount',
  facDateLastInformalAction: 'facDateLastInformalAction',
  facFormalActionCount: 'facFormalActionCount',
  facDateLastFormalAction: 'facDateLastFormalAction',
  facTotalPenalties: 'facTotalPenalties',
  facPenaltyCount: 'facPenaltyCount',
  facDateLastPenalty: 'facDateLastPenalty',
  facLastPenaltyAmt: 'facLastPenaltyAmt',
  facQtrsWithNc: 'facQtrsWithNc',
  facProgramsWithSnc: 'facProgramsWithSnc',
  facComplianceStatus: 'facComplianceStatus',
  facSncFlg: 'facSncFlg',
  fac3yrComplianceHistory: 'fac3yrComplianceHistory',
  airFlag: 'airFlag',
  npdesFlag: 'npdesFlag',
  sdwisFlag: 'sdwisFlag',
  rcraFlag: 'rcraFlag',
  triFlag: 'triFlag',
  ghgFlag: 'ghgFlag',
  airIds: 'airIds',
  caaPermitTypes: 'caaPermitTypes',
  caaNaics: 'caaNaics',
  caaSics: 'caaSics',
  caaEvaluationCount: 'caaEvaluationCount',
  caaDaysLastEvaluation: 'caaDaysLastEvaluation',
  caaInformalCount: 'caaInformalCount',
  caaFormalActionCount: 'caaFormalActionCount',
  caaDateLastFormalAction: 'caaDateLastFormalAction',
  caaPenalties: 'caaPenalties',
  caaLastPenaltyDate: 'caaLastPenaltyDate',
  caaLastPenaltyAmt: 'caaLastPenaltyAmt',
  caaQtrsWithNc: 'caaQtrsWithNc',
  caaComplianceStatus: 'caaComplianceStatus',
  caaHpvFlag: 'caaHpvFlag',
  caa3yrComplQtrsHistory: 'caa3yrComplQtrsHistory',
  npdesIds: 'npdesIds',
  cwaPermitTypes: 'cwaPermitTypes',
  cwaComplianceTracking: 'cwaComplianceTracking',
  cwaNaics: 'cwaNaics',
  cwaSics: 'cwaSics',
  cwaInspectionCount: 'cwaInspectionCount',
  cwaDaysLastInspection: 'cwaDaysLastInspection',
  cwaInformalCount: 'cwaInformalCount',
  cwaFormalActionCount: 'cwaFormalActionCount',
  cwaDateLastFormalAction: 'cwaDateLastFormalAction',
  cwaPenalties: 'cwaPenalties',
  cwaLastPenaltyDate: 'cwaLastPenaltyDate',
  cwaLastPenaltyAmt: 'cwaLastPenaltyAmt',
  cwaQtrsWithNc: 'cwaQtrsWithNc',
  cwaComplianceStatus: 'cwaComplianceStatus',
  cwaSncFlag: 'cwaSncFlag',
  cwa13qtrsComplHistory: 'cwa13qtrsComplHistory',
  cwa13qtrsEfflntExceedances: 'cwa13qtrsEfflntExceedances',
  cwa3yrQncrCodes: 'cwa3yrQncrCodes',
  rcraIds: 'rcraIds',
  rcraPermitTypes: 'rcraPermitTypes',
  rcraNaics: 'rcraNaics',
  rcraInspectionCount: 'rcraInspectionCount',
  rcraDaysLastEvaluation: 'rcraDaysLastEvaluation',
  rcraInformalCount: 'rcraInformalCount',
  rcraFormalActionCount: 'rcraFormalActionCount',
  rcraDateLastFormalAction: 'rcraDateLastFormalAction',
  rcraPenalties: 'rcraPenalties',
  rcraLastPenaltyDate: 'rcraLastPenaltyDate',
  rcraLastPenaltyAmt: 'rcraLastPenaltyAmt',
  rcraQtrsWithNc: 'rcraQtrsWithNc',
  rcraComplianceStatus: 'rcraComplianceStatus',
  rcraSncFlag: 'rcraSncFlag',
  rcra3yrComplQtrsHistory: 'rcra3yrComplQtrsHistory',
  sdwaIds: 'sdwaIds',
  sdwaSystemTypes: 'sdwaSystemTypes',
  sdwaInformalCount: 'sdwaInformalCount',
  sdwaFormalActionCount: 'sdwaFormalActionCount',
  sdwaComplianceStatus: 'sdwaComplianceStatus',
  sdwaSncFlag: 'sdwaSncFlag',
  triIds: 'triIds',
  triReleasesTransfers: 'triReleasesTransfers',
  triOnSiteReleases: 'triOnSiteReleases',
  triOffSiteTransfers: 'triOffSiteTransfers',
  triReporterInPast: 'triReporterInPast',
  fecCaseIds: 'fecCaseIds',
  fecNumberOfCases: 'fecNumberOfCases',
  fecLastCaseDate: 'fecLastCaseDate',
  fecTotalPenalties: 'fecTotalPenalties',
  ghgIds: 'ghgIds',
  ghgCo2Releases: 'ghgCo2Releases',
  dfrUrl: 'dfrUrl',
  facSicCodes: 'facSicCodes',
  facNaicsCodes: 'facNaicsCodes',
  facDateLastInspectionEpa: 'facDateLastInspectionEpa',
  facDateLastInspectionState: 'facDateLastInspectionState',
  facDateLastFormalActEpa: 'facDateLastFormalActEpa',
  facDateLastFormalActSt: 'facDateLastFormalActSt',
  facDateLastInformalActEpa: 'facDateLastInformalActEpa',
  facDateLastInformalActSt: 'facDateLastInformalActSt',
  facFederalAgency: 'facFederalAgency',
  triReporter: 'triReporter',
  facImpWaterFlg: 'facImpWaterFlg',
  ejscreenFlagUs: 'ejscreenFlagUs'
};

exports.Prisma.EchoFacilityMatchCandidateScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  registryId: 'registryId',
  matchScore: 'matchScore',
  jobId: 'jobId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.NpdesCsViolationScalarFieldEnum = {
  id: 'id',
  npdesId: 'npdesId',
  npdesViolationId: 'npdesViolationId',
  violationTypeCode: 'violationTypeCode',
  compScheduleEventId: 'compScheduleEventId',
  compScheduleNmbr: 'compScheduleNmbr',
  violationCode: 'violationCode',
  violationDesc: 'violationDesc',
  scheduleEventCode: 'scheduleEventCode',
  scheduleEventDesc: 'scheduleEventDesc',
  scheduleDate: 'scheduleDate',
  actualDate: 'actualDate',
  rncDetectionCode: 'rncDetectionCode',
  rncDetectionDesc: 'rncDetectionDesc',
  rncDetectionDate: 'rncDetectionDate',
  rncResolutionCode: 'rncResolutionCode',
  rncResolutionDesc: 'rncResolutionDesc',
  rncResolutionDate: 'rncResolutionDate',
  reportReceivedDate: 'reportReceivedDate'
};

exports.Prisma.NpdesEffViolationScalarFieldEnum = {
  npdesId: 'npdesId',
  versionNmbr: 'versionNmbr',
  activityId: 'activityId',
  npdesViolationId: 'npdesViolationId',
  monitoringPeriodEndDate: 'monitoringPeriodEndDate'
};

exports.Prisma.NpdesPsViolationScalarFieldEnum = {
  id: 'id',
  npdesId: 'npdesId',
  npdesViolationId: 'npdesViolationId',
  permScheduleEventId: 'permScheduleEventId',
  violationTypeCode: 'violationTypeCode',
  violationCode: 'violationCode',
  violationDesc: 'violationDesc',
  scheduleEventCode: 'scheduleEventCode',
  scheduleEventDesc: 'scheduleEventDesc',
  scheduleDate: 'scheduleDate',
  rncDetectionCode: 'rncDetectionCode',
  rncDetectionDesc: 'rncDetectionDesc',
  rncDetectionDate: 'rncDetectionDate',
  rncResolutionCode: 'rncResolutionCode',
  rncResolutionDesc: 'rncResolutionDesc',
  rncResolutionDate: 'rncResolutionDate',
  actualDate: 'actualDate',
  reportReceivedDate: 'reportReceivedDate'
};

exports.Prisma.NpdesSeViolationScalarFieldEnum = {
  id: 'id',
  npdesId: 'npdesId',
  npdesViolationId: 'npdesViolationId',
  violationTypeCode: 'violationTypeCode',
  violationCode: 'violationCode',
  violationDesc: 'violationDesc',
  singleEventViolationDate: 'singleEventViolationDate',
  singleEventEndDate: 'singleEventEndDate',
  singleEventViolationComment: 'singleEventViolationComment',
  singleEventAgencyTypeCode: 'singleEventAgencyTypeCode',
  rncDetectionCode: 'rncDetectionCode',
  rncDetectionDesc: 'rncDetectionDesc',
  rncDetectionDate: 'rncDetectionDate',
  rncResolutionCode: 'rncResolutionCode',
  rncResolutionDesc: 'rncResolutionDesc',
  rncResolutionDate: 'rncResolutionDate'
};

exports.Prisma.NpdesFacilityScalarFieldEnum = {
  icisFacilityInterestId: 'icisFacilityInterestId',
  npdesId: 'npdesId',
  facilityUin: 'facilityUin',
  facilityTypeCode: 'facilityTypeCode',
  facilityName: 'facilityName',
  locationAddress: 'locationAddress',
  supplementalAddressText: 'supplementalAddressText',
  city: 'city',
  countyCode: 'countyCode',
  stateCode: 'stateCode',
  zip: 'zip',
  geocodeLatitude: 'geocodeLatitude',
  geocodeLongitude: 'geocodeLongitude',
  impairedWaters: 'impairedWaters'
};

exports.Prisma.NpdesPermitScalarFieldEnum = {
  activityId: 'activityId',
  externalPermitNmbr: 'externalPermitNmbr',
  versionNmbr: 'versionNmbr',
  facilityTypeIndicator: 'facilityTypeIndicator',
  permitTypeCode: 'permitTypeCode',
  majorMinorStatusFlag: 'majorMinorStatusFlag',
  permitStatusCode: 'permitStatusCode',
  totalDesignFlowNmbr: 'totalDesignFlowNmbr',
  actualAverageFlowNmbr: 'actualAverageFlowNmbr',
  stateWaterBody: 'stateWaterBody',
  stateWaterBodyName: 'stateWaterBodyName',
  permitName: 'permitName',
  agencyTypeCode: 'agencyTypeCode',
  originalIssueDate: 'originalIssueDate',
  issueDate: 'issueDate',
  issuingAgency: 'issuingAgency',
  effectiveDate: 'effectiveDate',
  expirationDate: 'expirationDate',
  retirementDate: 'retirementDate',
  terminationDate: 'terminationDate',
  permitCompStatusFlag: 'permitCompStatusFlag',
  dmrNonReceiptFlag: 'dmrNonReceiptFlag',
  rncTrackingFlag: 'rncTrackingFlag',
  masterExternalPermitNmbr: 'masterExternalPermitNmbr',
  tmdlInterfaceFlag: 'tmdlInterfaceFlag',
  edmrAuthorizationFlag: 'edmrAuthorizationFlag',
  pretreatmentIndicatorCode: 'pretreatmentIndicatorCode',
  radWbdHuc12s: 'radWbdHuc12s'
};

exports.Prisma.NpdesQncrHistoryScalarFieldEnum = {
  npdesId: 'npdesId',
  yearqtr: 'yearqtr',
  hlrnc: 'hlrnc',
  nume90q: 'nume90q',
  numcvdt: 'numcvdt',
  numsvcd: 'numsvcd',
  numpsch: 'numpsch',
  numd8090q: 'numd8090q'
};

exports.Prisma.EchoRcraFacilityScalarFieldEnum = {
  idNumber: 'idNumber',
  facilityName: 'facilityName',
  activityLocation: 'activityLocation',
  fullEnforcement: 'fullEnforcement',
  hreportUniverseRecord: 'hreportUniverseRecord',
  streetAddress: 'streetAddress',
  cityName: 'cityName',
  stateCode: 'stateCode',
  zipCode: 'zipCode',
  latitude83: 'latitude83',
  longitude83: 'longitude83',
  fedWasteGenerator: 'fedWasteGenerator',
  transporter: 'transporter',
  activeSite: 'activeSite',
  operatingTsdf: 'operatingTsdf'
};

exports.Prisma.EchoRcraVioSncHistoryScalarFieldEnum = {
  idNumber: 'idNumber',
  activityLocation: 'activityLocation',
  yrmonth: 'yrmonth',
  vioFlag: 'vioFlag',
  sncFlag: 'sncFlag'
};

exports.Prisma.EchoRcraViolationScalarFieldEnum = {
  id: 'id',
  idNumber: 'idNumber',
  activityLocation: 'activityLocation',
  violationType: 'violationType',
  violationTypeDesc: 'violationTypeDesc',
  violDeterminedByAgency: 'violDeterminedByAgency',
  dateViolationDetermined: 'dateViolationDetermined',
  actualRtcDate: 'actualRtcDate',
  scheduledComplianceDate: 'scheduledComplianceDate'
};

exports.Prisma.NationalContactFileScalarFieldEnum = {
  id: 'id',
  registryId: 'registryId',
  pgmSysAcrnm: 'pgmSysAcrnm',
  pgmSysId: 'pgmSysId',
  interestType: 'interestType',
  affiliationType: 'affiliationType',
  startDate: 'startDate',
  endDate: 'endDate',
  fullName: 'fullName',
  title: 'title',
  phoneNumber: 'phoneNumber',
  alternatePhone: 'alternatePhone',
  faxNumber: 'faxNumber',
  emailAddress: 'emailAddress',
  mailingAddress: 'mailingAddress',
  supplementalAddress: 'supplementalAddress',
  cityName: 'cityName',
  stateCode: 'stateCode',
  stateName: 'stateName',
  postalCode: 'postalCode',
  countryName: 'countryName'
};

exports.Prisma.InsightsCohortScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  name: 'name',
  nameSearches: 'nameSearches',
  domainSearches: 'domainSearches'
};

exports.Prisma.HdHandlerScalarFieldEnum = {
  handlerId: 'handlerId',
  activityLocation: 'activityLocation',
  sourceType: 'sourceType',
  seqNumber: 'seqNumber',
  receiveDate: 'receiveDate',
  handlerName: 'handlerName',
  nonNotifier: 'nonNotifier',
  acknowledgeDate: 'acknowledgeDate',
  acknowledgeFlag: 'acknowledgeFlag',
  accessibility: 'accessibility',
  locationStreetNo: 'locationStreetNo',
  locationStreet1: 'locationStreet1',
  locationStreet2: 'locationStreet2',
  locationCity: 'locationCity',
  locationState: 'locationState',
  locationZip: 'locationZip',
  locationCountry: 'locationCountry',
  countyCode: 'countyCode',
  locationLatitude: 'locationLatitude',
  locationLongitude: 'locationLongitude',
  locationGisPrimary: 'locationGisPrimary',
  locationGisOrigin: 'locationGisOrigin',
  stateDistrictOwner: 'stateDistrictOwner',
  stateDistrict: 'stateDistrict',
  landType: 'landType',
  mailStreetNo: 'mailStreetNo',
  mailStreet1: 'mailStreet1',
  mailStreet2: 'mailStreet2',
  mailCity: 'mailCity',
  mailState: 'mailState',
  mailZip: 'mailZip',
  mailCountry: 'mailCountry',
  contactFirstName: 'contactFirstName',
  contactMiddleInitial: 'contactMiddleInitial',
  contactLastName: 'contactLastName',
  contactStreetNo: 'contactStreetNo',
  contactStreet1: 'contactStreet1',
  contactStreet2: 'contactStreet2',
  contactCity: 'contactCity',
  contactState: 'contactState',
  contactZip: 'contactZip',
  contactCountry: 'contactCountry',
  contactPhone: 'contactPhone',
  contactPhoneExt: 'contactPhoneExt',
  contactFax: 'contactFax',
  contactEmailAddress: 'contactEmailAddress',
  contactTitle: 'contactTitle',
  contactLanguage: 'contactLanguage',
  fedWasteGeneratorOwner: 'fedWasteGeneratorOwner',
  fedWasteGenerator: 'fedWasteGenerator',
  stateWasteGeneratorOwner: 'stateWasteGeneratorOwner',
  stateWasteGenerator: 'stateWasteGenerator',
  shortTermGenerator: 'shortTermGenerator',
  importerActivity: 'importerActivity',
  mixedWasteGenerator: 'mixedWasteGenerator',
  transporter: 'transporter',
  transferFacility: 'transferFacility',
  tsdActivity: 'tsdActivity',
  recyclerActivity: 'recyclerActivity',
  onsiteBurnerExemption: 'onsiteBurnerExemption',
  furnaceExemption: 'furnaceExemption',
  undergroundInjectionActivity: 'undergroundInjectionActivity',
  offSiteReceipt: 'offSiteReceipt',
  universalWasteDestFacility: 'universalWasteDestFacility',
  usedOilTransporter: 'usedOilTransporter',
  usedOilTransferFacility: 'usedOilTransferFacility',
  usedOilProcessor: 'usedOilProcessor',
  usedOilRefiner: 'usedOilRefiner',
  usedOilBurner: 'usedOilBurner',
  usedOilMarketBurner: 'usedOilMarketBurner',
  usedOilSpecMarketer: 'usedOilSpecMarketer',
  subpartKCollege: 'subpartKCollege',
  subpartKHospital: 'subpartKHospital',
  subpartKNonprofit: 'subpartKNonprofit',
  subpartKWithdrawal: 'subpartKWithdrawal',
  includeInNationalReport: 'includeInNationalReport',
  reportCycle: 'reportCycle',
  brExempt: 'brExempt',
  cdxTransactionId: 'cdxTransactionId',
  userId: 'userId',
  lastChange: 'lastChange',
  notes: 'notes',
  publicNotes: 'publicNotes',
  shortTermGeneratorNotes: 'shortTermGeneratorNotes',
  lqhuw: 'lqhuw',
  dataOrigin: 'dataOrigin',
  createdByUserId: 'createdByUserId',
  createdDate: 'createdDate',
  recognizedTraderImporter: 'recognizedTraderImporter',
  recognizedTraderExporter: 'recognizedTraderExporter',
  slabImporter: 'slabImporter',
  slabExporter: 'slabExporter',
  currentRecord: 'currentRecord',
  recyclerActivityNonstorage: 'recyclerActivityNonstorage',
  manifestBroker: 'manifestBroker',
  subpartPHealthcare: 'subpartPHealthcare',
  subpartPReverseDistributor: 'subpartPReverseDistributor',
  subpartPWithdrawal: 'subpartPWithdrawal',
  ownerName: 'ownerName',
  operatorName: 'operatorName'
};

exports.Prisma.HdOwnerOperatorScalarFieldEnum = {
  handlerId: 'handlerId',
  activityLocation: 'activityLocation',
  sourceType: 'sourceType',
  seqNumber: 'seqNumber',
  ownerOperatorSeq: 'ownerOperatorSeq',
  ownerOperatorIndicator: 'ownerOperatorIndicator',
  ownerOperatorType: 'ownerOperatorType',
  ownerOperatorName: 'ownerOperatorName',
  dateBecameCurrent: 'dateBecameCurrent',
  dateEndedCurrent: 'dateEndedCurrent',
  streetNo: 'streetNo',
  street1: 'street1',
  street2: 'street2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  country: 'country',
  phone: 'phone',
  phoneExt: 'phoneExt',
  fax: 'fax',
  email: 'email',
  publicNotes: 'publicNotes'
};

exports.Prisma.WasteLineScalarFieldEnum = {
  manifestId: 'manifestId',
  manifestTrackingNumber: 'manifestTrackingNumber',
  wasteLineNumber: 'wasteLineNumber',
  dotHazardous: 'dotHazardous',
  dotIdNumberDescription: 'dotIdNumberDescription',
  dotPrintedInformation: 'dotPrintedInformation',
  nonHazWasteDescription: 'nonHazWasteDescription',
  containerNumber: 'containerNumber',
  containerTypeCode: 'containerTypeCode',
  containerTypeDescription: 'containerTypeDescription',
  disposalManagementCode: 'disposalManagementCode',
  quantity: 'quantity',
  qtyUnitOfMeasureCode: 'qtyUnitOfMeasureCode',
  qtyUnitOfMeasureDesc: 'qtyUnitOfMeasureDesc',
  quantityTons: 'quantityTons',
  quantityAcuteTons: 'quantityAcuteTons',
  quantityNonAcuteTons: 'quantityNonAcuteTons',
  quantityKg: 'quantityKg',
  quantityAcuteKg: 'quantityAcuteKg',
  quantityNonAcuteKg: 'quantityNonAcuteKg',
  managementMethodCode: 'managementMethodCode',
  managementMethodDescription: 'managementMethodDescription',
  wasteResidue: 'wasteResidue',
  quantityDiscrepancy: 'quantityDiscrepancy',
  wasteTypeDiscrepancy: 'wasteTypeDiscrepancy',
  brDensity: 'brDensity',
  brDensityUomCode: 'brDensityUomCode',
  brDensityUomDescription: 'brDensityUomDescription',
  brFormCode: 'brFormCode',
  brFormCodeDescription: 'brFormCodeDescription',
  brSourceCode: 'brSourceCode',
  brSourceCodeDescription: 'brSourceCodeDescription',
  brWasteMinCode: 'brWasteMinCode',
  brWasteMinDescription: 'brWasteMinDescription',
  consentNumber: 'consentNumber',
  epaWaste: 'epaWaste',
  quantityHazKg: 'quantityHazKg',
  quantityHazTons: 'quantityHazTons',
  quantityNonHazKg: 'quantityNonHazKg',
  quantityNonHazTons: 'quantityNonHazTons',
  federalWasteCodes: 'federalWasteCodes',
  stateWasteCodes: 'stateWasteCodes',
  eManifestProfileNumber: 'eManifestProfileNumber',
  vendorProfileNumber: 'vendorProfileNumber',
  vendorProfileDescription: 'vendorProfileDescription',
  vendorComments: 'vendorComments',
  vendorClassification: 'vendorClassification',
  vendorTSDFApprovalCode: 'vendorTSDFApprovalCode',
  vendorDisposalMethod: 'vendorDisposalMethod',
  vendorWasteTypeDescription: 'vendorWasteTypeDescription',
  vendorWasteTypeCategory: 'vendorWasteTypeCategory',
  vendorBillUnit: 'vendorBillUnit',
  vendorBillQuantity: 'vendorBillQuantity',
  vendorUnitPrice: 'vendorUnitPrice',
  vendorSequenceID: 'vendorSequenceID',
  vendorDisposalDescription: 'vendorDisposalDescription',
  vendorFederal: 'vendorFederal',
  vendorStateHazLbs: 'vendorStateHazLbs',
  vendorUWLbs: 'vendorUWLbs',
  vendorServiceYearMonth: 'vendorServiceYearMonth',
  wasteStreamHashKey: 'wasteStreamHashKey',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WasteLineTagScalarFieldEnum = {
  id: 'id',
  tagId: 'tagId',
  manifestId: 'manifestId',
  wasteLineNumber: 'wasteLineNumber',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WasteManifestScalarFieldEnum = {
  id: 'id',
  manifestTrackingNumber: 'manifestTrackingNumber',
  manifestSource: 'manifestSource',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  updatedDate: 'updatedDate',
  shippedDate: 'shippedDate',
  receivedDate: 'receivedDate',
  status: 'status',
  submissionType: 'submissionType',
  originType: 'originType',
  generatorId: 'generatorId',
  generatorName: 'generatorName',
  generatorMailStreetNo: 'generatorMailStreetNo',
  generatorMailStreet1: 'generatorMailStreet1',
  generatorMailStreet2: 'generatorMailStreet2',
  generatorMailCity: 'generatorMailCity',
  generatorMailZip: 'generatorMailZip',
  generatorMailState: 'generatorMailState',
  generatorLocationStreetNo: 'generatorLocationStreetNo',
  generatorLocationStreet1: 'generatorLocationStreet1',
  generatorLocationStreet2: 'generatorLocationStreet2',
  generatorLocationCity: 'generatorLocationCity',
  generatorLocationZip: 'generatorLocationZip',
  generatorLocationState: 'generatorLocationState',
  generatorContactCompanyName: 'generatorContactCompanyName',
  desFacilityId: 'desFacilityId',
  desFacilityName: 'desFacilityName',
  desFacMailStreetNo: 'desFacMailStreetNo',
  desFacMailStreet1: 'desFacMailStreet1',
  desFacMailStreet2: 'desFacMailStreet2',
  desFacMailCity: 'desFacMailCity',
  desFacMailZip: 'desFacMailZip',
  desFacMailState: 'desFacMailState',
  desFacLocationStreetNo: 'desFacLocationStreetNo',
  desFacLocationStreet1: 'desFacLocationStreet1',
  desFacLocationStreet2: 'desFacLocationStreet2',
  desFacLocationCity: 'desFacLocationCity',
  desFacLocationZip: 'desFacLocationZip',
  desFacLocationState: 'desFacLocationState',
  desFacContactCompanyName: 'desFacContactCompanyName',
  manifestResidue: 'manifestResidue',
  rejection: 'rejection',
  totalQuantityAcuteKg: 'totalQuantityAcuteKg',
  totalQuantityAcuteTons: 'totalQuantityAcuteTons',
  totalQuantityHazKg: 'totalQuantityHazKg',
  totalQuantityHazTons: 'totalQuantityHazTons',
  totalQuantityNonAcuteKg: 'totalQuantityNonAcuteKg',
  totalQuantityNonAcuteTons: 'totalQuantityNonAcuteTons',
  totalQuantityNonHazKg: 'totalQuantityNonHazKg',
  totalQuantityNonHazTons: 'totalQuantityNonHazTons',
  totalQuantityKg: 'totalQuantityKg',
  totalQuantityTons: 'totalQuantityTons',
  brokerId: 'brokerId',
  ingestSource: 'ingestSource',
  manuallyEdited: 'manuallyEdited',
  vendorSource: 'vendorSource',
  vendorSiteId: 'vendorSiteId',
  vendorCompanyID: 'vendorCompanyID',
  vendorProfitCtrID: 'vendorProfitCtrID',
  vendorCustomerID: 'vendorCustomerID',
  vendorCustomerName: 'vendorCustomerName',
  vendorWorkOrderId: 'vendorWorkOrderId',
  vendorGeneratorID: 'vendorGeneratorID',
  vendorGeneratorSiteCode: 'vendorGeneratorSiteCode',
  vendorGeneratorSiteType: 'vendorGeneratorSiteType',
  vendorGeneratorSublocationCode: 'vendorGeneratorSublocationCode',
  vendorPurchaseOrder: 'vendorPurchaseOrder',
  vendorInvoiceCode: 'vendorInvoiceCode',
  vendorInvoiceDate: 'vendorInvoiceDate',
  vendorResourceType: 'vendorResourceType',
  vendorTSDFCode: 'vendorTSDFCode',
  vendorBillTotal: 'vendorBillTotal',
  vendorDisposalDescription: 'vendorDisposalDescription',
  vendorFederal: 'vendorFederal',
  vendorStateHazLbs: 'vendorStateHazLbs',
  vendorUWLbs: 'vendorUWLbs',
  vendorServiceYearMonth: 'vendorServiceYearMonth',
  originalManifestTrackingNumber: 'originalManifestTrackingNumber',
  originalShippedDate: 'originalShippedDate',
  originalVendorSource: 'originalVendorSource',
  originalDesFacilityName: 'originalDesFacilityName',
  eManifestCreatedDate: 'eManifestCreatedDate',
  eManifestCertifiedDate: 'eManifestCertifiedDate',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  isDemo: 'isDemo'
};

exports.Prisma.WasteTransporterScalarFieldEnum = {
  manifestId: 'manifestId',
  manifestTrackingNumber: 'manifestTrackingNumber',
  transporterLineNumber: 'transporterLineNumber',
  transporterId: 'transporterId',
  transporterName: 'transporterName',
  daysInPossession: 'daysInPossession',
  vendorAddressLine1: 'vendorAddressLine1',
  vendorAddressLine2: 'vendorAddressLine2',
  vendorCity: 'vendorCity',
  vendorState: 'vendorState',
  vendorZip: 'vendorZip',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityModelIssueScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  reportId: 'reportId',
  reportingYear: 'reportingYear',
  schemaPath: 'schemaPath',
  modelIssueId: 'modelIssueId',
  ignoreForReport: 'ignoreForReport'
};

exports.Prisma.FacilityModelIssueCountScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  reportId: 'reportId',
  reportingYear: 'reportingYear',
  count: 'count',
  countForReport: 'countForReport',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ModelIssueScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  modelName: 'modelName',
  modelId: 'modelId',
  message: 'message',
  propertyKey: 'propertyKey',
  dataName: 'dataName',
  validatedAt: 'validatedAt',
  isRevalidating: 'isRevalidating'
};

exports.Prisma.JobLogScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  status: 'status',
  taskArn: 'taskArn',
  taskDefinitionArn: 'taskDefinitionArn',
  errorMessage: 'errorMessage',
  stackTrace: 'stackTrace',
  cloudWatchLogStream: 'cloudWatchLogStream',
  screenshotKey: 'screenshotKey',
  htmlKey: 'htmlKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobStepsDoneScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobScalarFieldEnum = {
  id: 'id',
  task: 'task',
  status: 'status',
  runsOn: 'runsOn',
  parameters: 'parameters',
  taskArn: 'taskArn',
  taskDefinitionArn: 'taskDefinitionArn',
  action: 'action',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  reportId: 'reportId',
  documentId: 'documentId',
  initiatedByUserId: 'initiatedByUserId',
  requestId: 'requestId',
  encampRequestId: 'encampRequestId',
  credentialUsername: 'credentialUsername',
  credentialId: 'credentialId',
  stateOrTerritory: 'stateOrTerritory',
  forceClassicSubmissionStrategy: 'forceClassicSubmissionStrategy',
  evidenceOfCompletionActions: 'evidenceOfCompletionActions',
  stepError: 'stepError',
  reportingYear: 'reportingYear',
  extractionKey: 'extractionKey',
  output: 'output',
  staffReportKey: 'staffReportKey',
  totalIssues: 'totalIssues',
  createdBy: 'createdBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  promotedAt: 'promotedAt',
  promotedBy: 'promotedBy',
  activityId: 'activityId'
};

exports.Prisma.JobManagerConfigScalarFieldEnum = {
  id: 'id',
  task: 'task',
  maxConcurrency: 'maxConcurrency',
  createdBy: 'createdBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.LeadAgencyScalarFieldEnum = {
  id: 'id',
  address: 'address',
  name: 'name',
  additionalComments: 'additionalComments',
  attn: 'attn',
  city: 'city',
  consolidated: 'consolidated',
  phone: 'phone',
  state: 'state',
  zip: 'zip',
  email: 'email',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.LepcScalarFieldEnum = {
  id: 'id',
  name: 'name',
  state: 'state',
  city: 'city',
  county: 'county',
  zip: 'zip',
  mailingAddress: 'mailingAddress',
  mailingAddressLine2: 'mailingAddressLine2',
  contactName: 'contactName',
  email: 'email',
  phone: 'phone',
  feeStructure: 'feeStructure',
  latitude: 'latitude',
  longitude: 'longitude',
  leadAgencyId: 'leadAgencyId',
  leadAgencyName: 'leadAgencyName',
  paymentMethod: 'paymentMethod',
  t2sValue: 't2sValue',
  submissionNotes: 'submissionNotes',
  requirementDetails: 'requirementDetails',
  additionalComments: 'additionalComments',
  additionaRequirements: 'additionaRequirements',
  additionalFees: 'additionalFees',
  isEmailed: 'isEmailed',
  isCurrent1AsOf2021: 'isCurrent1AsOf2021',
  isMailed: 'isMailed',
  deactivated: 'deactivated',
  isStateSubmits: 'isStateSubmits',
  needsT2sFile: 'needsT2sFile',
  isSubmittedViaPortal: 'isSubmittedViaPortal',
  needsXmlZipFile: 'needsXmlZipFile',
  portalId: 'portalId',
  portalName: 'portalName',
  preferUncertified: 'preferUncertified',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.LinearWebhookEventScalarFieldEnum = {
  id: 'id',
  linearId: 'linearId',
  action: 'action',
  createdAt: 'createdAt',
  data: 'data',
  updatedFrom: 'updatedFrom',
  url: 'url',
  type: 'type',
  organizationId: 'organizationId',
  webhookTimestamp: 'webhookTimestamp'
};

exports.Prisma.LockScalarFieldEnum = {
  id: 'id',
  type: 'type',
  resourceId: 'resourceId',
  holderId: 'holderId',
  expiresAt: 'expiresAt',
  description: 'description',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.MergeRecordScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  winningId: 'winningId',
  losingId: 'losingId',
  losingData: 'losingData',
  tableName: 'tableName',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  message: 'message',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  tierIIReportId: 'tierIIReportId',
  submissionId: 'submissionId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.OneSchemaImportScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  templateType: 'templateType',
  templateKey: 'templateKey',
  rawFileKey: 'rawFileKey',
  cleanFileKey: 'cleanFileKey',
  oneSchemaEmbedId: 'oneSchemaEmbedId',
  requestIds: 'requestIds',
  status: 'status',
  processingMethod: 'processingMethod',
  userId: 'userId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  status: 'status',
  paymentMethod: 'paymentMethod',
  amount: 'amount',
  description: 'description',
  memo: 'memo',
  payee: 'payee',
  paidAt: 'paidAt',
  recordedByEmail: 'recordedByEmail',
  documentId: 'documentId',
  createdBy: 'createdBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  activityId: 'activityId',
  lobMailId: 'lobMailId',
  jobId: 'jobId',
  payeeType: 'payeeType',
  company: 'company',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  billable: 'billable',
  exceptionNote: 'exceptionNote',
  reconciliationStatus: 'reconciliationStatus',
  reconciledAt: 'reconciledAt',
  reconciledBy: 'reconciledBy'
};

exports.Prisma.PaymentCommentScalarFieldEnum = {
  id: 'id',
  paymentId: 'paymentId',
  message: 'message',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  deleted: 'deleted',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy',
  createdByEmail: 'createdByEmail'
};

exports.Prisma.PaymentInvoiceScalarFieldEnum = {
  id: 'id',
  payee: 'payee',
  invoiceNumber: 'invoiceNumber',
  invoiceDocumentId: 'invoiceDocumentId',
  dateDue: 'dateDue',
  amount: 'amount',
  description: 'description',
  paymentId: 'paymentId'
};

exports.Prisma.PaymentReconciliationHistoryScalarFieldEnum = {
  id: 'id',
  paymentId: 'paymentId',
  previousStatus: 'previousStatus',
  newStatus: 'newStatus',
  changedBy: 'changedBy',
  changedByEmail: 'changedByEmail',
  changedAt: 'changedAt'
};

exports.Prisma.PersonScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  first: 'first',
  last: 'last',
  email: 'email',
  title: 'title',
  company: 'company',
  streetAddress1: 'streetAddress1',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  country: 'country',
  phones: 'phones',
  isEncamp: 'isEncamp',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  createdAtViaMerge: 'createdAtViaMerge',
  attentionTo: 'attentionTo',
  dbNumber: 'dbNumber',
  tankOwnerType: 'tankOwnerType'
};

exports.Prisma.PipelineScalarFieldEnum = {
  id: 'id',
  name: 'name',
  tenantId: 'tenantId',
  lastRunAt: 'lastRunAt',
  inputFiles: 'inputFiles',
  outputFiles: 'outputFiles',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.PoliceDepartmentScalarFieldEnum = {
  id: 'id',
  address: 'address',
  name: 'name',
  additionalComments: 'additionalComments',
  attn: 'attn',
  city: 'city',
  state: 'state',
  zip: 'zip',
  email: 'email',
  contactName: 'contactName',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.PortalScalarFieldEnum = {
  id: 'id',
  type: 'type',
  jurisdiction: 'jurisdiction',
  url: 'url',
  capacity: 'capacity',
  allowsMultiSessionLogin: 'allowsMultiSessionLogin',
  allowsCookieReuse: 'allowsCookieReuse',
  requiresUsageOfChemicalDb: 'requiresUsageOfChemicalDb',
  usesMFA: 'usesMFA',
  supportedProgramAreas: 'supportedProgramAreas',
  description: 'description',
  isActive: 'isActive',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  alternateId: 'alternateId',
  reference: 'reference',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ProductChemicalScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  chemicalId: 'chemicalId',
  amount: 'amount',
  unit: 'unit',
  storageType: 'storageType',
  storageTypeDescription: 'storageTypeDescription',
  pressure: 'pressure',
  temperature: 'temperature',
  otherPressureValue: 'otherPressureValue',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ProductChemicalOverrideScalarFieldEnum = {
  id: 'id',
  productChemicalId: 'productChemicalId',
  jurisdiction: 'jurisdiction',
  storageType: 'storageType',
  storageTypeDescription: 'storageTypeDescription',
  pressure: 'pressure',
  otherPressureValue: 'otherPressureValue',
  temperature: 'temperature'
};

exports.Prisma.ProductTenantScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  tenantId: 'tenantId'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  permissions: 'permissions',
  tenantId: 'tenantId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SnapshotScalarFieldEnum = {
  id: 'id',
  type: 'type',
  sourceId: 'sourceId',
  content: 'content',
  dataModelVersion: 'dataModelVersion',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.StorageLocationScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  description: 'description',
  CA_mapNumber: 'CA_mapNumber',
  CA_gridNumber: 'CA_gridNumber',
  OR_insideOutside: 'OR_insideOutside',
  OR_storageBuilding: 'OR_storageBuilding',
  OR_storageFloor: 'OR_storageFloor',
  OR_storageArea: 'OR_storageArea',
  OR_storageRoom: 'OR_storageRoom',
  OR_storageQuadrant: 'OR_storageQuadrant',
  NV_insideOutside: 'NV_insideOutside',
  latitude: 'latitude',
  longitude: 'longitude',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilitySubmissionScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  submissionId: 'submissionId',
  isExempt: 'isExempt',
  exemptionReason: 'exemptionReason',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SubmissionScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  title: 'title',
  submissionType: 'submissionType',
  status: 'status',
  requirementStatus: 'requirementStatus',
  recipient: 'recipient',
  submissionMethod: 'submissionMethod',
  reportingPeriodStart: 'reportingPeriodStart',
  reportingPeriodEnd: 'reportingPeriodEnd',
  dueDate: 'dueDate',
  submittedAt: 'submittedAt',
  staffAssigneeId: 'staffAssigneeId',
  reviewRequired: 'reviewRequired',
  reviewMode: 'reviewMode',
  signedAt: 'signedAt',
  signatureType: 'signatureType',
  notes: 'notes',
  metadata: 'metadata',
  requirementJurisdictions: 'requirementJurisdictions',
  source: 'source',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SubmissionDocumentScalarFieldEnum = {
  id: 'id',
  submissionId: 'submissionId',
  documentId: 'documentId',
  documentSource: 'documentSource',
  reviewRequired: 'reviewRequired',
  type: 'type',
  externalDocumentId: 'externalDocumentId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SubmissionDocumentReviewScalarFieldEnum = {
  id: 'id',
  submissionReviewerId: 'submissionReviewerId',
  submissionDocumentId: 'submissionDocumentId',
  reviewerStatus: 'reviewerStatus',
  signatureStatus: 'signatureStatus',
  completedAt: 'completedAt',
  hasViewed: 'hasViewed',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SubmissionPaymentScalarFieldEnum = {
  id: 'id',
  submissionId: 'submissionId',
  paymentId: 'paymentId',
  description: 'description',
  amount: 'amount',
  isRequired: 'isRequired',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SubmissionReviewerScalarFieldEnum = {
  id: 'id',
  submissionId: 'submissionId',
  userId: 'userId',
  reviewOrder: 'reviewOrder',
  isStaff: 'isStaff',
  isRequired: 'isRequired',
  isSigner: 'isSigner',
  dueDate: 'dueDate',
  completedAt: 'completedAt',
  streetAddress1: 'streetAddress1',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  country: 'country',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SubmissionTagScalarFieldEnum = {
  id: 'id',
  submissionId: 'submissionId',
  tagId: 'tagId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SupplementalFireDepartmentScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  fireDepartmentId: 'fireDepartmentId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SupplementalLepcScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  lepcId: 'lepcId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  tenantId: 'tenantId',
  icon: 'icon',
  isDisabled: 'isDisabled',
  isInternal: 'isInternal',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  createdBy: 'createdBy'
};

exports.Prisma.TaskScalarFieldEnum = {
  id: 'id',
  seriesId: 'seriesId',
  title: 'title',
  description: 'description',
  completedAt: 'completedAt',
  reminderDays: 'reminderDays',
  completedById: 'completedById',
  assigneeId: 'assigneeId',
  links: 'links',
  tenantId: 'tenantId',
  submissionId: 'submissionId',
  frequency: 'frequency',
  interval: 'interval',
  endDate: 'endDate',
  startDate: 'startDate',
  excludedDates: 'excludedDates',
  isSuggested: 'isSuggested',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy'
};

exports.Prisma.SubTaskScalarFieldEnum = {
  id: 'id',
  taskId: 'taskId',
  title: 'title',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy'
};

exports.Prisma.TaskTagScalarFieldEnum = {
  id: 'id',
  tagId: 'tagId',
  taskId: 'taskId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.TenantScalarFieldEnum = {
  id: 'id',
  name: 'name',
  partnerTenantId: 'partnerTenantId',
  salesforceId: 'salesforceId',
  isDemo: 'isDemo',
  isPartner: 'isPartner',
  isDisabled: 'isDisabled',
  externalId: 'externalId',
  roleIdToDefaultForNewUsers: 'roleIdToDefaultForNewUsers',
  ssoMappingName: 'ssoMappingName',
  ssoIssuerUrl: 'ssoIssuerUrl',
  ssoMetadataUrl: 'ssoMetadataUrl',
  ssoDomains: 'ssoDomains',
  signsAllReportPages: 'signsAllReportPages',
  selfSignedCertification: 'selfSignedCertification',
  salesforceSyncedAt: 'salesforceSyncedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.TenantConfigScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  tenantId: 'tenantId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.TenantContactScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  type: 'type',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  userId: 'userId',
  salesforceContactId: 'salesforceContactId',
  syncedAt: 'syncedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy'
};

exports.Prisma.ReportFacilityDocumentScalarFieldEnum = {
  id: 'id',
  facilityDocumentId: 'facilityDocumentId',
  tierIIReportId: 'tierIIReportId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.TierIIReportScalarFieldEnum = {
  id: 'id',
  organizationStatus: 'organizationStatus',
  encampStatus: 'encampStatus',
  productCount: 'productCount',
  facilityId: 'facilityId',
  reportingYear: 'reportingYear',
  currentWorkflowId: 'currentWorkflowId',
  tenantId: 'tenantId',
  verifierFullName: 'verifierFullName',
  verifierTitle: 'verifierTitle',
  verifierPhone: 'verifierPhone',
  verifierEmail: 'verifierEmail',
  verifiedAt: 'verifiedAt',
  verifiedByEncamp: 'verifiedByEncamp',
  reportKind: 'reportKind',
  submittedAt: 'submittedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  reasonForReport: 'reasonForReport',
  notesToRegulators: 'notesToRegulators',
  department: 'department',
  fulfillmentNote: 'fulfillmentNote',
  needsRevision: 'needsRevision',
  needsRevisionReason: 'needsRevisionReason',
  touchedSteps: 'touchedSteps',
  touchedCASteps: 'touchedCASteps',
  tags: 'tags',
  reviewCompletedByUserId: 'reviewCompletedByUserId',
  filedBy: 'filedBy',
  portalReportId: 'portalReportId',
  requiresReviewers: 'requiresReviewers'
};

exports.Prisma.TierIIReportAssigneeScalarFieldEnum = {
  id: 'id',
  tierIIReportId: 'tierIIReportId',
  personId: 'personId',
  assignmentType: 'assignmentType',
  isComplete: 'isComplete',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.TierIIReportPaymentScalarFieldEnum = {
  paymentId: 'paymentId',
  tierIIReportId: 'tierIIReportId',
  amount: 'amount'
};

exports.Prisma.TierIIReportStatusLogScalarFieldEnum = {
  id: 'id',
  tierIIReportId: 'tierIIReportId',
  statusType: 'statusType',
  status: 'status',
  timestamp: 'timestamp',
  statusUpdatedBy: 'statusUpdatedBy',
  createdAt: 'createdAt',
  createdBy: 'createdBy'
};

exports.Prisma.TierIIReportSubmissionMeasureScalarFieldEnum = {
  id: 'id',
  index: 'index',
  name: 'name',
  description: 'description',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  notes: 'notes',
  records: 'records',
  tierIIReportId: 'tierIIReportId'
};

exports.Prisma.TierIIReportUstStatusScalarFieldEnum = {
  tierIIReportId: 'tierIIReportId',
  undergroundStorageTankId: 'undergroundStorageTankId',
  touchedSteps: 'touchedSteps'
};

exports.Prisma.TierIIReportValidationScalarFieldEnum = {
  id: 'id',
  errors: 'errors',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  tierIIReportId: 'tierIIReportId'
};

exports.Prisma.UndergroundStorageTankScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  tankId: 'tankId',
  nickname: 'nickname',
  typeOfAction: 'typeOfAction',
  manufacturer: 'manufacturer',
  capacityGallons: 'capacityGallons',
  installationDate: 'installationDate',
  existingDiscoveredDate: 'existingDiscoveredDate',
  permanentlyClosedDate: 'permanentlyClosedDate',
  configuration: 'configuration',
  numberOfCompartments: 'numberOfCompartments',
  additionalDescription: 'additionalDescription',
  tankUsage: 'tankUsage',
  tankUsageOther: 'tankUsageOther',
  tankContents: 'tankContents',
  tankContentsOther: 'tankContentsOther',
  type: 'type',
  constructionPrimaryContainment: 'constructionPrimaryContainment',
  constructionPrimaryContainmentOther: 'constructionPrimaryContainmentOther',
  constructionSecondaryContainment: 'constructionSecondaryContainment',
  constructionSecondaryContainmentOther: 'constructionSecondaryContainmentOther',
  overfillProtection: 'overfillProtection',
  pipingConstruction: 'pipingConstruction',
  pipingSystemType: 'pipingSystemType',
  productWastePrimaryContainment: 'productWastePrimaryContainment',
  productWastePrimaryContainmentOther: 'productWastePrimaryContainmentOther',
  productWasteSecondaryContainment: 'productWasteSecondaryContainment',
  productWasteSecondaryContainmentOther: 'productWasteSecondaryContainmentOther',
  pipingTurbineContainmentSump: 'pipingTurbineContainmentSump',
  ventPrimaryContainment: 'ventPrimaryContainment',
  ventPrimaryContainmentOther: 'ventPrimaryContainmentOther',
  ventSecondaryContainment: 'ventSecondaryContainment',
  ventSecondaryContainmentOther: 'ventSecondaryContainmentOther',
  vaporRecoveryPrimaryContainment: 'vaporRecoveryPrimaryContainment',
  vaporRecoveryPrimaryContainmentOther: 'vaporRecoveryPrimaryContainmentOther',
  vaporRecoverySecondaryContainment: 'vaporRecoverySecondaryContainment',
  vaporRecoverySecondaryContainmentOther: 'vaporRecoverySecondaryContainmentOther',
  riserPipePrimaryContainment: 'riserPipePrimaryContainment',
  riserPipePrimaryContainmentOther: 'riserPipePrimaryContainmentOther',
  riserPipeSecondaryContainment: 'riserPipeSecondaryContainment',
  riserPipeSecondaryContainmentOther: 'riserPipeSecondaryContainmentOther',
  ventPipingTransitionSumps: 'ventPipingTransitionSumps',
  fillComponentsInstalled: 'fillComponentsInstalled',
  constructionType: 'constructionType',
  constructionMaterial: 'constructionMaterial',
  constructionMaterialOther: 'constructionMaterialOther',
  corrosionProtection: 'corrosionProtection',
  monitoringEquipmentServiced: 'monitoringEquipmentServiced',
  monitoringEquipmentServicedOther: 'monitoringEquipmentServicedOther',
  sitePlotPlanSubmitted: 'sitePlotPlanSubmitted',
  udcMonitoring: 'udcMonitoring',
  udcMonitoringOther: 'udcMonitoringOther',
  udcPanelManufacturer: 'udcPanelManufacturer',
  udcPanelModel: 'udcPanelModel',
  udcLeakSensorManufacturer: 'udcLeakSensorManufacturer',
  udcLeakSensorModel: 'udcLeakSensorModel',
  hasUdcLeakDetection: 'hasUdcLeakDetection',
  hasUdcLeakAlarmTriggerShutdown: 'hasUdcLeakAlarmTriggerShutdown',
  hasUdcFailureTriggerShutdown: 'hasUdcFailureTriggerShutdown',
  hasUdcMonitoringStopFlow: 'hasUdcMonitoringStopFlow',
  udcConstruction: 'udcConstruction',
  udcSecondaryContactMonitoring: 'udcSecondaryContactMonitoring',
  hasUdcSecondaryLeakDetection: 'hasUdcSecondaryLeakDetection',
  periodicSystemTesting: 'periodicSystemTesting',
  recordKeeping: 'recordKeeping',
  ustPersonnelFamiliarTraining: 'ustPersonnelFamiliarTraining',
  otherTrainingDocuments: 'otherTrainingDocuments',
  designatedOperatorTraining: 'designatedOperatorTraining',
  additionalInformation: 'additionalInformation',
  firstNameResponsibility: 'firstNameResponsibility',
  firstNameTitle: 'firstNameTitle',
  secondNameResponsibility: 'secondNameResponsibility',
  secondNameTitle: 'secondNameTitle',
  tankMonitoringMethod: 'tankMonitoringMethod',
  continuousElectronicTankMonitoringSecondaryContainmentSystem: 'continuousElectronicTankMonitoringSecondaryContainmentSystem',
  continuousElectronicTankMonitoringEmpManufacturer: 'continuousElectronicTankMonitoringEmpManufacturer',
  continuousElectronicTankMonitoringEmpModelNumber: 'continuousElectronicTankMonitoringEmpModelNumber',
  continuousElectronicTankMonitoringLeakSensorManufacturer: 'continuousElectronicTankMonitoringLeakSensorManufacturer',
  continuousElectronicTankMonitoringLeakSensorModelNumber: 'continuousElectronicTankMonitoringLeakSensorModelNumber',
  automaticTankGaugingAtgPanelManufacturer: 'automaticTankGaugingAtgPanelManufacturer',
  automaticTankGaugingAtgModelNumber: 'automaticTankGaugingAtgModelNumber',
  automaticTankGaugingProbeManufacturer: 'automaticTankGaugingProbeManufacturer',
  automaticTankGaugingProbeModelNumber: 'automaticTankGaugingProbeModelNumber',
  automaticTankGaugingLeakTestFrequency: 'automaticTankGaugingLeakTestFrequency',
  automaticTankGaugingLeakTestFrequencyOther: 'automaticTankGaugingLeakTestFrequencyOther',
  automaticTankGaugingProgrammedTankTests: 'automaticTankGaugingProgrammedTankTests',
  automaticTankGaugingProgrammedTankTestsOther: 'automaticTankGaugingProgrammedTankTestsOther',
  weeklyManualTankGaugeGaugingTestPeriod: 'weeklyManualTankGaugeGaugingTestPeriod',
  integrityTestingFrequency: 'integrityTestingFrequency',
  integrityTestingFrequencyOther: 'integrityTestingFrequencyOther',
  otherMonitoring: 'otherMonitoring',
  pipeMonitoringMethod: 'pipeMonitoringMethod',
  pipeSecContainmentMonitoringPipingSecondaryContainment: 'pipeSecContainmentMonitoringPipingSecondaryContainment',
  pipeSecContainmentMonitoringPanelManufacturer: 'pipeSecContainmentMonitoringPanelManufacturer',
  pipeSecContainmentMonitoringPanelModelNumber: 'pipeSecContainmentMonitoringPanelModelNumber',
  pipeSecContainmentMonitoringLeakSensorManufacturer: 'pipeSecContainmentMonitoringLeakSensorManufacturer',
  pipeSecContainmentMonitoringLeakSensorModelNumber: 'pipeSecContainmentMonitoringLeakSensorModelNumber',
  pipeSecContainmentMonitoringLeakAlarmTriggersAutoPumpShutdown: 'pipeSecContainmentMonitoringLeakAlarmTriggersAutoPumpShutdown',
  pipeSecContainmentMonitoringFailureTriggersPumpShutdown: 'pipeSecContainmentMonitoringFailureTriggersPumpShutdown',
  mechanicalLineLeakDetectorManufacturer: 'mechanicalLineLeakDetectorManufacturer',
  mechanicalLineLeakDetectorModelNumber: 'mechanicalLineLeakDetectorModelNumber',
  electronicLineLeakDetectorManufacturer: 'electronicLineLeakDetectorManufacturer',
  electronicLineLeakDetectorModelNumber: 'electronicLineLeakDetectorModelNumber',
  electronicLineLeakDetectorProgrammedInlineTesting: 'electronicLineLeakDetectorProgrammedInlineTesting',
  electronicLineLeakDetectorTriggersAutoPumpShutdown: 'electronicLineLeakDetectorTriggersAutoPumpShutdown',
  electronicLineLeakDetectorFailureTriggersPumpShutdown: 'electronicLineLeakDetectorFailureTriggersPumpShutdown',
  pipelineIntegrityTestingFrequency: 'pipelineIntegrityTestingFrequency',
  pipelineIntegrityTestingFrequencyOther: 'pipelineIntegrityTestingFrequencyOther',
  visualPipelineMonitoringFrequency: 'visualPipelineMonitoringFrequency',
  otherPipelineMonitoring: 'otherPipelineMonitoring',
  previouslyReported: 'previouslyReported',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.UndergroundStorageTankCertificationScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  certifiedWork: 'certifiedWork',
  certifiedWorkPermit: 'certifiedWorkPermit',
  certifiedWorkDescription: 'certifiedWorkDescription',
  contractorName: 'contractorName',
  contractorLicenseNumber: 'contractorLicenseNumber',
  contractorICCCertificationNumber: 'contractorICCCertificationNumber',
  certifierName: 'certifierName',
  certifierTitle: 'certifierTitle',
  certifierPhoneNumber: 'certifierPhoneNumber',
  certifierEmployer: 'certifierEmployer',
  certifierRelationToTankOwner: 'certifierRelationToTankOwner',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  type: 'type',
  invitedAt: 'invitedAt',
  invitationExpiresAt: 'invitationExpiresAt',
  status: 'status',
  personId: 'personId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.UserCalendarTokenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  token: 'token',
  createdAt: 'createdAt',
  lastUsedAt: 'lastUsedAt'
};

exports.Prisma.UserCognitoScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  cognitoSub: 'cognitoSub'
};

exports.Prisma.UserFacilityScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  userId: 'userId'
};

exports.Prisma.UserLoginScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  loginAt: 'loginAt'
};

exports.Prisma.UserTenantScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  userId: 'userId',
  roleId: 'roleId'
};

exports.Prisma.FacilityWasteStreamScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  wasteStreamHashKey: 'wasteStreamHashKey',
  dotDescription: 'dotDescription',
  classification: 'classification',
  federalWasteCodes: 'federalWasteCodes',
  stateWasteCodes: 'stateWasteCodes',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityWasteStreamAmountScalarFieldEnum = {
  id: 'id',
  facilityWasteStreamId: 'facilityWasteStreamId',
  month: 'month',
  amountInPounds: 'amountInPounds',
  originalUnit: 'originalUnit',
  originalUnitAmount: 'originalUnitAmount',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.FacilityWasteStreamYearToDateScalarFieldEnum = {
  id: 'id',
  year: 'year',
  managementMethodCodes: 'managementMethodCodes',
  finalDestinations: 'finalDestinations',
  shipments: 'shipments',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  facilityWasteStreamId: 'facilityWasteStreamId'
};

exports.Prisma.IngestSummaryScalarFieldEnum = {
  id: 'id',
  s3Key: 's3Key',
  facilitiesUpdated: 'facilitiesUpdated',
  rcraCodesCreated: 'rcraCodesCreated',
  wasteTransportersCreated: 'wasteTransportersCreated',
  wasteDisposalFacilitiesCreated: 'wasteDisposalFacilitiesCreated',
  wasteStreamsCreated: 'wasteStreamsCreated',
  wasteStreamsUpdated: 'wasteStreamsUpdated',
  manifestsCreated: 'manifestsCreated',
  manifestsUpdated: 'manifestsUpdated',
  manifestLineItemsCreated: 'manifestLineItemsCreated',
  manifestLineItemsUpdated: 'manifestLineItemsUpdated',
  owner: 'owner',
  createdAt: 'createdAt',
  createdBy: 'createdBy'
};

exports.Prisma.StateWasteCodeScalarFieldEnum = {
  id: 'id',
  state: 'state',
  value: 'value',
  definition: 'definition',
  classification: 'classification',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WasteLineUnifiedScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  epaId: 'epaId',
  vendorSiteId: 'vendorSiteId',
  manifestTrackingNumber: 'manifestTrackingNumber',
  processedManifestId: 'processedManifestId',
  wasteStreamRawId: 'wasteStreamRawId',
  shippedDate: 'shippedDate',
  wasteLineNumber: 'wasteLineNumber',
  willNotReport: 'willNotReport',
  manuallyEdited: 'manuallyEdited',
  vendorManifestId: 'vendorManifestId',
  vendorManifestUpdatedDate: 'vendorManifestUpdatedDate',
  vendorProfileNumber: 'vendorProfileNumber',
  vendorDotIdNumberDescription: 'vendorDotIdNumberDescription',
  vendorDotPrintedInformation: 'vendorDotPrintedInformation',
  vendorNonHazWasteDescription: 'vendorNonHazWasteDescription',
  vendorFederalWasteCodes: 'vendorFederalWasteCodes',
  vendorStateWasteCodes: 'vendorStateWasteCodes',
  vendorManagementMethodCode: 'vendorManagementMethodCode',
  vendorManagementMethodDescription: 'vendorManagementMethodDescription',
  vendorFormCode: 'vendorFormCode',
  vendorFormCodeDescription: 'vendorFormCodeDescription',
  vendorSourceCode: 'vendorSourceCode',
  vendorSourceCodeDescription: 'vendorSourceCodeDescription',
  vendorWasteMinimizationCode: 'vendorWasteMinimizationCode',
  vendorWasteMinimizationDescription: 'vendorWasteMinimizationDescription',
  vendorConsentNumber: 'vendorConsentNumber',
  vendorDotHazardous: 'vendorDotHazardous',
  vendorEpaWaste: 'vendorEpaWaste',
  vendorWasteResidue: 'vendorWasteResidue',
  vendorClassification: 'vendorClassification',
  vendorAmount: 'vendorAmount',
  vendorProfileDescription: 'vendorProfileDescription',
  vendorComments: 'vendorComments',
  originalVendorProfileDescription: 'originalVendorProfileDescription',
  originalVendorDotPrintedInformation: 'originalVendorDotPrintedInformation',
  originalVendorNonHazWasteDescription: 'originalVendorNonHazWasteDescription',
  originalVendorAmount: 'originalVendorAmount',
  originalVendorProfileNumber: 'originalVendorProfileNumber',
  originalVendorManagementMethodCode: 'originalVendorManagementMethodCode',
  eManifestId: 'eManifestId',
  eManifestUpdatedDate: 'eManifestUpdatedDate',
  eManifestProfileNumber: 'eManifestProfileNumber',
  eManifestDotIdNumberDescription: 'eManifestDotIdNumberDescription',
  eManifestDotPrintedInformation: 'eManifestDotPrintedInformation',
  eManifestNonHazWasteDescription: 'eManifestNonHazWasteDescription',
  eManifestFederalWasteCodes: 'eManifestFederalWasteCodes',
  eManifestStateWasteCodes: 'eManifestStateWasteCodes',
  eManifestManagementMethodCode: 'eManifestManagementMethodCode',
  eManifestManagementMethodDescription: 'eManifestManagementMethodDescription',
  eManifestFormCode: 'eManifestFormCode',
  eManifestFormCodeDescription: 'eManifestFormCodeDescription',
  eManifestSourceCode: 'eManifestSourceCode',
  eManifestSourceCodeDescription: 'eManifestSourceCodeDescription',
  eManifestWasteMinimizationCode: 'eManifestWasteMinimizationCode',
  eManifestWasteMinimizationDescription: 'eManifestWasteMinimizationDescription',
  eManifestConsentNumber: 'eManifestConsentNumber',
  eManifestDotHazardous: 'eManifestDotHazardous',
  eManifestEpaWaste: 'eManifestEpaWaste',
  eManifestWasteResidue: 'eManifestWasteResidue',
  eManifestAmount: 'eManifestAmount',
  tagIds: 'tagIds',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WasteLineUnifiedTagScalarFieldEnum = {
  id: 'id',
  tagId: 'tagId',
  wasteLineUnifiedId: 'wasteLineUnifiedId',
  wasteLineUnifiedShippedDate: 'wasteLineUnifiedShippedDate',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WasteManifestVendorScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WasteStreamScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  name: 'name',
  classification: 'classification',
  internalNote: 'internalNote',
  comment: 'comment',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WasteStreamRawScalarFieldEnum = {
  id: 'id',
  wasteStreamHashKey: 'wasteStreamHashKey',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  epaId: 'epaId',
  vendorSiteId: 'vendorSiteId',
  wasteStreamId: 'wasteStreamId',
  name: 'name',
  eManifestProfileNumber: 'eManifestProfileNumber',
  vendorProfileNumber: 'vendorProfileNumber',
  classification: 'classification',
  federalWasteCodes: 'federalWasteCodes',
  stateWasteCodes: 'stateWasteCodes',
  managementMethodCode: 'managementMethodCode',
  formCode: 'formCode',
  sourceCode: 'sourceCode',
  wasteMinimizationCode: 'wasteMinimizationCode',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ActivityScalarFieldEnum = {
  id: 'id',
  type: 'type',
  status: 'status',
  executionPlan: 'executionPlan',
  description: 'description',
  output: 'output',
  reportDetailsExtended: 'reportDetailsExtended',
  championId: 'championId',
  nonChampionIds: 'nonChampionIds',
  cohortFacilityIds: 'cohortFacilityIds',
  assigneeId: 'assigneeId',
  workflowId: 'workflowId',
  currentJobId: 'currentJobId',
  lobMailId: 'lobMailId',
  message: 'message',
  cohortTypes: 'cohortTypes',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  tier2SubmitValidationStatus: 'tier2SubmitValidationStatus',
  tier2SubmitValidationErrors: 'tier2SubmitValidationErrors',
  tier2SubmitValidationWarnings: 'tier2SubmitValidationWarnings'
};

exports.Prisma.ActivityLogScalarFieldEnum = {
  id: 'id',
  activityId: 'activityId',
  status: 'status',
  message: 'message',
  errorType: 'errorType',
  stackTrace: 'stackTrace',
  time: 'time'
};

exports.Prisma.ActivityUserInputScalarFieldEnum = {
  id: 'id',
  activityId: 'activityId',
  label: 'label',
  shortName: 'shortName',
  type: 'type',
  value: 'value',
  required: 'required',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ActivityCohortScalarFieldEnum = {
  id: 'id',
  activityId: 'activityId',
  cohortId: 'cohortId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ActivityDocumentScalarFieldEnum = {
  activityId: 'activityId',
  documentId: 'documentId'
};

exports.Prisma.WorkflowScalarFieldEnum = {
  id: 'id',
  type: 'type',
  name: 'name',
  description: 'description',
  status: 'status',
  completedAt: 'completedAt',
  version: 'version',
  graph: 'graph',
  history: 'history',
  currentActivityId: 'currentActivityId',
  tierIIReportId: 'tierIIReportId',
  cohortId: 'cohortId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WorkflowManagerConfigScalarFieldEnum = {
  id: 'id',
  type: 'type',
  value: 'value',
  notes: 'notes',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.WorkflowTagScalarFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  tagId: 'tagId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ZipCodeScalarFieldEnum = {
  id: 'id',
  stateFips: 'stateFips',
  stateFullName: 'stateFullName',
  state: 'state',
  zip: 'zip',
  county: 'county',
  city: 'city',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.ChemicalAnomalyScalarFieldEnum = {
  tenantId: 'tenantId',
  reportingYear: 'reportingYear',
  facilityName: 'facilityName',
  facilityId: 'facilityId',
  chemicalName: 'chemicalName',
  chemicalId: 'chemicalId',
  previousYearMaxAmount: 'previousYearMaxAmount',
  previousYearUnit: 'previousYearUnit',
  previousYearReportId: 'previousYearReportId',
  currentYearMaxAmount: 'currentYearMaxAmount',
  currentYearUnit: 'currentYearUnit',
  currentYearReportId: 'currentYearReportId',
  changeType: 'changeType',
  percentageChange: 'percentageChange'
};

exports.Prisma.EchoExporterAggregatedScalarFieldEnum = {
  registryId: 'registryId',
  echoFacilityName: 'echoFacilityName',
  facilityStreet: 'facilityStreet',
  facilityCity: 'facilityCity',
  facilityState: 'facilityState',
  facilityZip: 'facilityZip',
  facilityCounty: 'facilityCounty',
  facActiveFlag: 'facActiveFlag',
  airFlag: 'airFlag',
  npdesFlag: 'npdesFlag',
  rcraFlag: 'rcraFlag',
  triFlag: 'triFlag',
  echoFacilityNaicsCodes: 'echoFacilityNaicsCodes',
  echoFirstNaicsCode: 'echoFirstNaicsCode',
  facComplianceStatus: 'facComplianceStatus',
  violationStatuteCodes: 'violationStatuteCodes',
  penaltyStatuteCodes: 'penaltyStatuteCodes',
  nonComplianceCountLast12Qrtrs: 'nonComplianceCountLast12Qrtrs',
  violationCountLast12Qrtrs: 'violationCountLast12Qrtrs',
  penaltiesLast12Qrtrs: 'penaltiesLast12Qrtrs',
  rcraHistoricalCompliance: 'rcraHistoricalCompliance',
  cwaHistoricalCompliance: 'cwaHistoricalCompliance',
  caaHistoricalCompliance: 'caaHistoricalCompliance',
  rcraIds: 'rcraIds',
  npdesIds: 'npdesIds',
  pgmSysIds: 'pgmSysIds'
};

exports.Prisma.ProcessedManifestViewScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  facilityId: 'facilityId',
  manifestTrackingNumber: 'manifestTrackingNumber',
  eManifestId: 'eManifestId',
  vendorManifestId: 'vendorManifestId',
  hasIssues: 'hasIssues',
  hasIssuesReason: 'hasIssuesReason',
  shippedDate: 'shippedDate',
  epaId: 'epaId',
  destinationFacilityId: 'destinationFacilityId',
  destinationFacilityName: 'destinationFacilityName',
  receivedDate: 'receivedDate',
  vendorSource: 'vendorSource',
  eManifestCreatedDate: 'eManifestCreatedDate',
  eManifestCertifiedDate: 'eManifestCertifiedDate',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  isRegulatedEManifest: 'isRegulatedEManifest',
  receivedByTsdf: 'receivedByTsdf',
  eManifestDaysInTransit: 'eManifestDaysInTransit',
  wasteLineCount: 'wasteLineCount'
};

exports.Prisma.FacilityEPAIdsScalarFieldEnum = {
  facilityId: 'facilityId',
  epaId: 'epaId',
  currentWasteGeneratorStatus: 'currentWasteGeneratorStatus',
  receiveDate: 'receiveDate'
};

exports.Prisma.FacilityEchoExporterScalarFieldEnum = {
  key: 'key',
  facilityId: 'facilityId',
  encampFacilityName: 'encampFacilityName',
  echoFacilityName: 'echoFacilityName',
  facilityStatus: 'facilityStatus',
  tenantId: 'tenantId',
  customerFacilityId: 'customerFacilityId',
  naicsCode: 'naicsCode',
  naics3: 'naics3',
  registryId: 'registryId',
  echoFacilityNaicsCodes: 'echoFacilityNaicsCodes',
  echoFirstNaicsCode: 'echoFirstNaicsCode',
  facActiveFlag: 'facActiveFlag',
  airFlag: 'airFlag',
  npdesFlag: 'npdesFlag',
  rcraFlag: 'rcraFlag',
  triFlag: 'triFlag',
  facComplianceStatus: 'facComplianceStatus',
  facilityStreet: 'facilityStreet',
  facilityCity: 'facilityCity',
  facilityState: 'facilityState',
  facilityZip: 'facilityZip',
  facilityCounty: 'facilityCounty',
  violationStatuteCodes: 'violationStatuteCodes',
  penaltyStatuteCodes: 'penaltyStatuteCodes',
  nonComplianceCountLast12Qrtrs: 'nonComplianceCountLast12Qrtrs',
  violationCountLast12Qrtrs: 'violationCountLast12Qrtrs',
  penaltiesLast12Qrtrs: 'penaltiesLast12Qrtrs',
  rcraHistoricalCompliance: 'rcraHistoricalCompliance',
  cwaHistoricalCompliance: 'cwaHistoricalCompliance',
  caaHistoricalCompliance: 'caaHistoricalCompliance',
  rcraIds: 'rcraIds',
  npdesIds: 'npdesIds',
  pgmSysIds: 'pgmSysIds'
};

exports.Prisma.FacilityRCRAInfoExporterScalarFieldEnum = {
  facilityId: 'facilityId',
  handlerId: 'handlerId',
  currentWasteGeneratorStatus: 'currentWasteGeneratorStatus',
  receiveDate: 'receiveDate'
};

exports.Prisma.FacilityTierIIReportScalarFieldEnum = {
  viewId: 'viewId',
  tierIIReportId: 'tierIIReportId',
  productCount: 'productCount',
  reportingYear: 'reportingYear',
  reportKind: 'reportKind',
  encampStatus: 'encampStatus',
  organizationStatus: 'organizationStatus',
  tenantId: 'tenantId',
  tenantName: 'tenantName',
  facilityId: 'facilityId',
  customerFacilityId: 'customerFacilityId',
  facilityName: 'facilityName',
  facilityDateClosed: 'facilityDateClosed',
  facilityDateInactive: 'facilityDateInactive',
  facilityTagNames: 'facilityTagNames',
  facilityStatus: 'facilityStatus',
  state: 'state',
  streetAddress1: 'streetAddress1',
  streetAddress2: 'streetAddress2',
  city: 'city',
  county: 'county',
  zip: 'zip',
  isInactive: 'isInactive',
  isClosed: 'isClosed',
  colocationReportingFacilityId: 'colocationReportingFacilityId',
  isNotReporting: 'isNotReporting',
  isNotReportingThroughEncamp: 'isNotReportingThroughEncamp',
  organizationStatusAnnual: 'organizationStatusAnnual',
  encampStatusAnnual: 'encampStatusAnnual',
  hasOpenRevision: 'hasOpenRevision',
  hasVerifiedRevision: 'hasVerifiedRevision',
  hasOpenInitial: 'hasOpenInitial',
  hasVerifiedInitial: 'hasVerifiedInitial',
  reportUpdatedAt: 'reportUpdatedAt',
  reportUpdatedBy: 'reportUpdatedBy',
  reportCreatedAt: 'reportCreatedAt',
  reportCreatedBy: 'reportCreatedBy',
  issueCount: 'issueCount',
  chemicalFeatureFlagOverride: 'chemicalFeatureFlagOverride',
  filedOn: 'filedOn'
};

exports.Prisma.SnapshotReportingFacilityChemicalScalarFieldEnum = {
  id: 'id',
  sourceId: 'sourceId',
  facilityId: 'facilityId',
  reportingYear: 'reportingYear',
  rfc_content: 'rfc_content',
  unit: 'unit',
  chemical_id: 'chemical_id',
  chemical_name: 'chemical_name',
  chemical_is_ehs: 'chemical_is_ehs',
  chemical_cas_number: 'chemical_cas_number',
  chemical_alternate_id: 'chemical_alternate_id',
  maxAmount: 'maxAmount',
  averageAmount: 'averageAmount',
  isOverThreshold: 'isOverThreshold',
  reporting_status: 'reporting_status'
};

exports.Prisma.TierIIReportActivityScalarFieldEnum = {
  id: 'id',
  tierIIReportId: 'tierIIReportId',
  productCount: 'productCount',
  reportingYear: 'reportingYear',
  reportKind: 'reportKind',
  encampStatus: 'encampStatus',
  jobStatus: 'jobStatus',
  organizationStatus: 'organizationStatus',
  tenantId: 'tenantId',
  tenantIsDemo: 'tenantIsDemo',
  tenantIsDisabled: 'tenantIsDisabled',
  organizationName: 'organizationName',
  facilityId: 'facilityId',
  facilityName: 'facilityName',
  facilityChemicalFeatureFlagOverride: 'facilityChemicalFeatureFlagOverride',
  customerFacilityId: 'customerFacilityId',
  cersId: 'cersId',
  state: 'state',
  streetAddress1: 'streetAddress1',
  streetAddress2: 'streetAddress2',
  city: 'city',
  zip: 'zip',
  county: 'county',
  lepcId: 'lepcId',
  lepcName: 'lepcName',
  fdId: 'fdId',
  fdName: 'fdName',
  hasIncompleteReviews: 'hasIncompleteReviews',
  tags: 'tags',
  issueCount: 'issueCount',
  filedOn: 'filedOn',
  workflowId: 'workflowId',
  workflowStatus: 'workflowStatus',
  workflowName: 'workflowName',
  workflowDescription: 'workflowDescription',
  graph: 'graph',
  activityId: 'activityId',
  activityType: 'activityType',
  activityDescription: 'activityDescription',
  activityExecutionPlan: 'activityExecutionPlan',
  activityStatus: 'activityStatus',
  activityErrorMessage: 'activityErrorMessage',
  activityAssigneeId: 'activityAssigneeId',
  activityAssigneeEmail: 'activityAssigneeEmail',
  activityAssigneeFirst: 'activityAssigneeFirst',
  activityAssigneeLast: 'activityAssigneeLast',
  isChampionReport: 'isChampionReport',
  cohortChampionIds: 'cohortChampionIds',
  partnerTenant: 'partnerTenant'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.Provider = exports.$Enums.Provider = {
  OPENAI: 'OPENAI',
  ANTHROPIC: 'ANTHROPIC'
};

exports.PureOrMixture = exports.$Enums.PureOrMixture = {
  PURE: 'PURE',
  MIXTURE: 'MIXTURE'
};

exports.DensityUnits = exports.$Enums.DensityUnits = {
  POUNDS_PER_CUBIC_FOOT: 'POUNDS_PER_CUBIC_FOOT',
  POUNDS_PER_GALLON: 'POUNDS_PER_GALLON',
  POUNDS_PER_LITER: 'POUNDS_PER_LITER',
  POUNDS_PER_BARREL: 'POUNDS_PER_BARREL',
  KILOGRAMS_PER_GALLON: 'KILOGRAMS_PER_GALLON',
  KILOGRAMS_PER_LITER: 'KILOGRAMS_PER_LITER',
  KILOGRAMS_PER_CUBIC_FOOT: 'KILOGRAMS_PER_CUBIC_FOOT',
  KILOGRAMS_PER_BARREL: 'KILOGRAMS_PER_BARREL',
  TONS_PER_GALLON: 'TONS_PER_GALLON',
  TONS_PER_LITER: 'TONS_PER_LITER',
  TONS_PER_CUBIC_FOOT: 'TONS_PER_CUBIC_FOOT',
  TONS_PER_BARREL: 'TONS_PER_BARREL',
  METRIC_TONS_PER_GALLON: 'METRIC_TONS_PER_GALLON',
  METRIC_TONS_PER_LITER: 'METRIC_TONS_PER_LITER',
  METRIC_TONS_PER_CUBIC_FOOT: 'METRIC_TONS_PER_CUBIC_FOOT',
  METRIC_TONS_PER_BARREL: 'METRIC_TONS_PER_BARREL'
};

exports.EhsForm = exports.$Enums.EhsForm = {
  MOLTEN: 'MOLTEN',
  SOLUTION: 'SOLUTION',
  SOLID_PARTICLE_SIZE_LESS_THAN_100_MICRON: 'SOLID_PARTICLE_SIZE_LESS_THAN_100_MICRON',
  NONE: 'NONE'
};

exports.StateOfMatter = exports.$Enums.StateOfMatter = {
  SOLID: 'SOLID',
  LIQUID: 'LIQUID',
  GAS: 'GAS'
};

exports.PhysicalHazard = exports.$Enums.PhysicalHazard = {
  EXPLOSIVE: 'EXPLOSIVE',
  FLAMMABLE: 'FLAMMABLE',
  OXIDIZER: 'OXIDIZER',
  SELF_REACTIVE: 'SELF_REACTIVE',
  PYROPHORIC_SOLID_OR_LIQUID: 'PYROPHORIC_SOLID_OR_LIQUID',
  PYROPHORIC_GAS: 'PYROPHORIC_GAS',
  SELF_HEATING: 'SELF_HEATING',
  ORGANIC_PEROXIDE: 'ORGANIC_PEROXIDE',
  CORROSIVE_TO_METAL: 'CORROSIVE_TO_METAL',
  COMPRESSED_GAS: 'COMPRESSED_GAS',
  FLAMMABLE_WITH_WATER: 'FLAMMABLE_WITH_WATER',
  COMBUSTIBLE_DUST: 'COMBUSTIBLE_DUST',
  UNCLASSIFIED_PHYSICAL_HAZARD: 'UNCLASSIFIED_PHYSICAL_HAZARD'
};

exports.HealthHazard = exports.$Enums.HealthHazard = {
  ACUTE_TOXICITY: 'ACUTE_TOXICITY',
  SKIN_IRRITANT: 'SKIN_IRRITANT',
  EYE_IRRITANT: 'EYE_IRRITANT',
  CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION: 'CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION',
  GERM_CELL_MUTAGENIC: 'GERM_CELL_MUTAGENIC',
  CARCINOGENIC: 'CARCINOGENIC',
  REPRODUCTIVE_TOXICITY: 'REPRODUCTIVE_TOXICITY',
  SPECIFIC_TARGET_ORGAN_TOXICITY: 'SPECIFIC_TARGET_ORGAN_TOXICITY',
  ASPIRATION_HAZARD: 'ASPIRATION_HAZARD',
  SIMPLE_ASPHYXIANT: 'SIMPLE_ASPHYXIANT',
  HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH: 'HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH'
};

exports.OregonHazard = exports.$Enums.OregonHazard = {
  RADIOACTIVE: 'RADIOACTIVE',
  POISONOUS_GAS: 'POISONOUS_GAS',
  POISONOUS_MATERIAL: 'POISONOUS_MATERIAL',
  INFECTIOUS_OR_ETIOLOGIC: 'INFECTIOUS_OR_ETIOLOGIC'
};

exports.InternationalFireCodeHazard = exports.$Enums.InternationalFireCodeHazard = {
  COMBUSTIBLE: 'COMBUSTIBLE',
  CORROSIVE: 'CORROSIVE',
  FLAMMABLE: 'FLAMMABLE',
  INERT: 'INERT',
  OXIDIZING: 'OXIDIZING',
  RADIOACTIVE: 'RADIOACTIVE',
  UNSTABLE: 'UNSTABLE',
  EXPLOSIVE: 'EXPLOSIVE',
  HIGHLY_TOXIC: 'HIGHLY_TOXIC',
  ORGANIC_PEROXIDES: 'ORGANIC_PEROXIDES',
  PYROPHORIC: 'PYROPHORIC',
  TOXIC: 'TOXIC',
  WATER_REACTIVE: 'WATER_REACTIVE'
};

exports.WeightOrVolume = exports.$Enums.WeightOrVolume = {
  WEIGHT: 'WEIGHT',
  VOLUME: 'VOLUME'
};

exports.ProgramArea = exports.$Enums.ProgramArea = {
  EPCRA: 'EPCRA',
  RCRA: 'RCRA'
};

exports.CohortType = exports.$Enums.CohortType = {
  FIRE_DEPARTMENT: 'FIRE_DEPARTMENT',
  LEPC: 'LEPC',
  CREDENTIAL: 'CREDENTIAL',
  ALTERNATE_ID: 'ALTERNATE_ID',
  STATE: 'STATE'
};

exports.CohortStatus = exports.$Enums.CohortStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED'
};

exports.CohortMemberStatus = exports.$Enums.CohortMemberStatus = {
  UNKNOWN: 'UNKNOWN',
  NOT_PARTICIPATING: 'NOT_PARTICIPATING',
  NOT_READY: 'NOT_READY',
  READY: 'READY'
};

exports.CommunicationType = exports.$Enums.CommunicationType = {
  CERTIFIED_MAIL: 'CERTIFIED_MAIL',
  FIRST_CLASS_MAIL: 'FIRST_CLASS_MAIL',
  CHECK: 'CHECK',
  EMAIL: 'EMAIL'
};

exports.CommunicationStatus = exports.$Enums.CommunicationStatus = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  SENT_TO_MAIL_CLIENT: 'SENT_TO_MAIL_CLIENT',
  SENT_TO_EMAIL_CLIENT: 'SENT_TO_EMAIL_CLIENT',
  ERROR: 'ERROR'
};

exports.LobMailType = exports.$Enums.LobMailType = {
  CHECK: 'CHECK',
  LETTER: 'LETTER'
};

exports.LobMailStatus = exports.$Enums.LobMailStatus = {
  MAILED: 'MAILED',
  IN_TRANSIT: 'IN_TRANSIT',
  IN_LOCAL_AREA: 'IN_LOCAL_AREA',
  PROCESSED_FOR_DELIVERY: 'PROCESSED_FOR_DELIVERY',
  DELIVERED: 'DELIVERED',
  RE_ROUTED: 'RE_ROUTED',
  RETURNED_TO_SENDER: 'RETURNED_TO_SENDER',
  INTERNATIONAL_EXIT: 'INTERNATIONAL_EXIT',
  ISSUE: 'ISSUE',
  PICKUP_AVAILABLE: 'PICKUP_AVAILABLE'
};

exports.CredentialKind = exports.$Enums.CredentialKind = {
  RCRA_COUNTY: 'RCRA_COUNTY',
  RCRA_STATE: 'RCRA_STATE',
  RCRA_FEDERAL: 'RCRA_FEDERAL',
  RCRA_PAYMENT: 'RCRA_PAYMENT',
  TIERII: 'TIERII',
  LEPC: 'LEPC'
};

exports.CredentialVerificationStatus = exports.$Enums.CredentialVerificationStatus = {
  NOT_ATTEMPTED: 'NOT_ATTEMPTED',
  CURRENTLY_VERIFYING: 'CURRENTLY_VERIFYING',
  GOOD: 'GOOD',
  INVALID_ACCESSID_OR_PASSWORD: 'INVALID_ACCESSID_OR_PASSWORD',
  BAD_USERNAME: 'BAD_USERNAME',
  BAD_PASSWORD: 'BAD_PASSWORD',
  BAD_SECURITY_QUESTION_ANSWER: 'BAD_SECURITY_QUESTION_ANSWER',
  EXPIRED_PASSWORD: 'EXPIRED_PASSWORD',
  IN_USE: 'IN_USE',
  REQUIRES_NEW_PASSWORD: 'REQUIRES_NEW_PASSWORD',
  LOCKED: 'LOCKED',
  UNKNOWN_NON_VERIFIABLE: 'UNKNOWN_NON_VERIFIABLE',
  UNKNOWN_ERROR_NEEDS_HUMAN: 'UNKNOWN_ERROR_NEEDS_HUMAN',
  FAILED_ONE_TIME_PASSWORD: 'FAILED_ONE_TIME_PASSWORD'
};

exports.DocumentType = exports.$Enums.DocumentType = {
  ASTDocumentation: 'ASTDocumentation',
  Certification: 'Certification',
  Check: 'Check',
  CoverLetter: 'CoverLetter',
  DikeDescription: 'DikeDescription',
  EmergencyResponsePlan: 'EmergencyResponsePlan',
  EPCRA302: 'EPCRA302',
  EPCRA304: 'EPCRA304',
  EPCRA311: 'EPCRA311',
  EPCRA312: 'EPCRA312',
  EPCRA313: 'EPCRA313',
  FeeCalculation: 'FeeCalculation',
  Fees: 'Fees',
  Form: 'Form',
  HazardousMaterialsContingencyPlanOrQuickGuide: 'HazardousMaterialsContingencyPlanOrQuickGuide',
  HazardousMaterialsInventoryStatement: 'HazardousMaterialsInventoryStatement',
  HazardousMaterialsManagementPlan: 'HazardousMaterialsManagementPlan',
  HazardousWasteAnnualReport: 'HazardousWasteAnnualReport',
  HazardousWasteBiennialReport: 'HazardousWasteBiennialReport',
  HazardousWasteContingencyPlan: 'HazardousWasteContingencyPlan',
  HazardousWasteFeesReceipts: 'HazardousWasteFeesReceipts',
  HazardousWasteNotification: 'HazardousWasteNotification',
  HazardousWasteQuarterlyReport: 'HazardousWasteQuarterlyReport',
  HazardousWasteRecertification: 'HazardousWasteRecertification',
  Invoice: 'Invoice',
  NegativeDeclaration: 'NegativeDeclaration',
  Other: 'Other',
  OtherRCRA: 'OtherRCRA',
  P2Plan: 'P2Plan',
  P2Update: 'P2Update',
  Permit: 'Permit',
  Proof: 'Proof',
  RCRAAnnual: 'RCRAAnnual',
  RCRAFeePaymentOrInvoice: 'RCRAFeePaymentOrInvoice',
  RCRAManifest: 'RCRAManifest',
  RCRAUpdateNotification: 'RCRAUpdateNotification',
  Receipt: 'Receipt',
  ReferenceImage: 'ReferenceImage',
  Report: 'Report',
  RevisionOrUpdate: 'RevisionOrUpdate',
  SafeguardMeasures: 'SafeguardMeasures',
  SafetyDataSheet: 'SafetyDataSheet',
  Screenshot: 'Screenshot',
  SiteCoordinateAbbreviation: 'SiteCoordinateAbbreviation',
  SitePlan: 'SitePlan',
  SpillPreventionControlAndCountermeasurePlan: 'SpillPreventionControlAndCountermeasurePlan',
  Submission: 'Submission',
  TrainingPlan: 'TrainingPlan',
  USTDocumentation: 'USTDocumentation',
  USTMonitoringSitePlan: 'USTMonitoringSitePlan',
  USTCertificationOfFinancialResponsibility: 'USTCertificationOfFinancialResponsibility',
  USTResponsePlan: 'USTResponsePlan',
  USTOwnerOperatorWrittenAgreement: 'USTOwnerOperatorWrittenAgreement',
  USTLetterFromChiefFinancialOfficer: 'USTLetterFromChiefFinancialOfficer',
  OwnerStatementOfDesignatedUSTOperatorCompliance: 'OwnerStatementOfDesignatedUSTOperatorCompliance',
  RecyclableMaterialsReportDocumentation: 'RecyclableMaterialsReportDocumentation',
  HazardousWasteTankClosureCertificate: 'HazardousWasteTankClosureCertificate',
  AboveGroundPetroleumStorageActDocumentation: 'AboveGroundPetroleumStorageActDocumentation',
  AboveGroundSeparationContainmentAndMonitoringPlan: 'AboveGroundSeparationContainmentAndMonitoringPlan'
};

exports.ExtractionStatus = exports.$Enums.ExtractionStatus = {
  NOT_ATTEMPTED: 'NOT_ATTEMPTED',
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
};

exports.Permission = exports.$Enums.Permission = {
  RouteEPCRA: 'RouteEPCRA',
  RouteRCRA: 'RouteRCRA',
  RouteFacilities: 'RouteFacilities',
  RouteCalendar: 'RouteCalendar',
  RouteContacts: 'RouteContacts',
  RouteDocuments: 'RouteDocuments',
  RouteEPCRAOverview: 'RouteEPCRAOverview',
  RouteEPCRATierII: 'RouteEPCRATierII',
  RouteEPCRAReports: 'RouteEPCRAReports',
  RouteEPCRAProducts: 'RouteEPCRAProducts',
  RouteEPCRACredentials: 'RouteEPCRACredentials',
  RouteInsights: 'RouteInsights',
  ReadOrgEventSequences: 'ReadOrgEventSequences',
  WriteOrgEventSequences: 'WriteOrgEventSequences',
  ReadAllFacility: 'ReadAllFacility',
  ReadAllFacilityMinimal: 'ReadAllFacilityMinimal',
  WriteAllFacility: 'WriteAllFacility',
  CreateFacility: 'CreateFacility',
  EditOwnFacilityPermissions: 'EditOwnFacilityPermissions',
  EditOwnFacilityPermissionsUnlimited: 'EditOwnFacilityPermissionsUnlimited',
  ReadAllUserTenant: 'ReadAllUserTenant',
  WriteAllUserTenant: 'WriteAllUserTenant',
  CreateUserTenant: 'CreateUserTenant',
  ReadUserTenantRole: 'ReadUserTenantRole',
  WriteUserTenantRole: 'WriteUserTenantRole',
  ReadRole: 'ReadRole',
  WriteRole: 'WriteRole',
  ReadPerson: 'ReadPerson',
  WritePerson: 'WritePerson',
  ReadFacilityContact: 'ReadFacilityContact',
  WriteFacilityContact: 'WriteFacilityContact',
  ReadSystemAuditLog: 'ReadSystemAuditLog',
  ReadUserActivityLog: 'ReadUserActivityLog',
  CreateDataCollectionTask: 'CreateDataCollectionTask',
  WriteDataCollectionTask: 'WriteDataCollectionTask',
  FulfillDataCollectionTask: 'FulfillDataCollectionTask',
  WriteDataCollectionTaskTemplate: 'WriteDataCollectionTaskTemplate',
  WriteAllCalendarEvent: 'WriteAllCalendarEvent',
  VerifyTierIIReport: 'VerifyTierIIReport',
  ManageReviewerRequirements: 'ManageReviewerRequirements',
  ViewCredentials: 'ViewCredentials'
};

exports.WorkflowType = exports.$Enums.WorkflowType = {
  TierIIReportSubmission: 'TierIIReportSubmission',
  Cohort: 'Cohort'
};

exports.ActivityType = exports.$Enums.ActivityType = {
  AddDocument: 'AddDocument',
  CollectEvidence: 'CollectEvidence',
  CollectEvidenceOfCompletion: 'CollectEvidenceOfCompletion',
  CreatePdf: 'CreatePdf',
  CreateZip: 'CreateZip',
  DistributeCohortDocuments: 'DistributeCohortDocuments',
  FillPdf: 'FillPdf',
  Geppetto: 'Geppetto',
  GenerateCustomerDeliverables: 'GenerateCustomerDeliverables',
  Lob: 'Lob',
  Presubmission: 'Presubmission',
  SendEmail: 'SendEmail',
  SendSupplementalAgencyCommunication: 'SendSupplementalAgencyCommunication',
  SignReportPages: 'SignReportPages',
  Staff: 'Staff',
  Tier2Submit: 'Tier2Submit',
  Tier2SubmitValidation: 'Tier2SubmitValidation',
  ValidateCohort: 'ValidateCohort',
  WaitForAllAltIdReports: 'WaitForAllAltIdReports',
  WaitForAllCNReports: 'WaitForAllCNReports',
  WaitForAllCredentialReports: 'WaitForAllCredentialReports',
  WaitForAllStateReports: 'WaitForAllStateReports',
  WaitForAllFD: 'WaitForAllFD',
  WaitForAllLEPC: 'WaitForAllLEPC',
  InitializeCohorts: 'InitializeCohorts',
  WaitForCohorts: 'WaitForCohorts',
  ValidateCohortMembership: 'ValidateCohortMembership'
};

exports.FederalRegulatoryStatus = exports.$Enums.FederalRegulatoryStatus = {
  LARGE_QUANTITY_GENERATOR: 'LARGE_QUANTITY_GENERATOR',
  SMALL_QUANTITY_GENERATOR: 'SMALL_QUANTITY_GENERATOR',
  VERY_SMALL_QUANTITY_GENERATOR: 'VERY_SMALL_QUANTITY_GENERATOR',
  NOT_A_GENERATOR: 'NOT_A_GENERATOR',
  UNDETERMINED: 'UNDETERMINED',
  PENDING: 'PENDING'
};

exports.StateRegulatoryStatus = exports.$Enums.StateRegulatoryStatus = {
  LARGE_QUANTITY_GENERATOR: 'LARGE_QUANTITY_GENERATOR',
  SMALL_QUANTITY_GENERATOR: 'SMALL_QUANTITY_GENERATOR',
  VERY_SMALL_QUANTITY_GENERATOR: 'VERY_SMALL_QUANTITY_GENERATOR',
  CONDITIONALLY_EXEMPT_SMALL_QUANTITY_GENERATOR: 'CONDITIONALLY_EXEMPT_SMALL_QUANTITY_GENERATOR',
  KANSAS_SMALL_QUANTITY_GENERATOR: 'KANSAS_SMALL_QUANTITY_GENERATOR',
  MARYLAND_GENERATOR_FULLY_REGULATED: 'MARYLAND_GENERATOR_FULLY_REGULATED',
  MEDIUM_QUANTITY_GENERATOR: 'MEDIUM_QUANTITY_GENERATOR',
  TEXAS_CLASS_1_ONLY_GENERATOR: 'TEXAS_CLASS_1_ONLY_GENERATOR',
  MINI_QUANTITY_GENERATOR: 'MINI_QUANTITY_GENERATOR',
  NOT_A_GENERATOR: 'NOT_A_GENERATOR',
  PENDING: 'PENDING',
  SAME_AS_FEDERAL: 'SAME_AS_FEDERAL',
  UNDETERMINED: 'UNDETERMINED'
};

exports.FacilityStatus = exports.$Enums.FacilityStatus = {
  PLANNED: 'PLANNED',
  OPEN: 'OPEN',
  INACTIVE: 'INACTIVE',
  CLOSED: 'CLOSED'
};

exports.CollectionMode = exports.$Enums.CollectionMode = {
  AGGREGATE: 'AGGREGATE',
  MEASUREMENT: 'MEASUREMENT'
};

exports.FeatureFlagOverride = exports.$Enums.FeatureFlagOverride = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  INHERIT_LD_FLAG_FOR_TENANT: 'INHERIT_LD_FLAG_FOR_TENANT'
};

exports.UnitType = exports.$Enums.UnitType = {
  POUNDS: 'POUNDS',
  GALLONS: 'GALLONS',
  CUBIC_FEET: 'CUBIC_FEET',
  TONS: 'TONS',
  KILOGRAMS: 'KILOGRAMS',
  METRIC_TONS: 'METRIC_TONS',
  LITERS: 'LITERS',
  BARRELS: 'BARRELS'
};

exports.Pressure = exports.$Enums.Pressure = {
  AMBIENT_PRESSURE: 'AMBIENT_PRESSURE',
  GREATER_THAN_AMBIENT_PRESSURE: 'GREATER_THAN_AMBIENT_PRESSURE',
  LESS_THAN_AMBIENT_PRESSURE: 'LESS_THAN_AMBIENT_PRESSURE',
  OTHER: 'OTHER'
};

exports.Temperature = exports.$Enums.Temperature = {
  AMBIENT_TEMPERATURE: 'AMBIENT_TEMPERATURE',
  CRYOGENIC_CONDITIONS: 'CRYOGENIC_CONDITIONS',
  GREATER_THAN_AMBIENT_TEMPERATURE: 'GREATER_THAN_AMBIENT_TEMPERATURE',
  LESS_THAN_AMBIENT_TEMPERATURE_BUT_NOT_CRYOGENIC: 'LESS_THAN_AMBIENT_TEMPERATURE_BUT_NOT_CRYOGENIC'
};

exports.ContactReportRole = exports.$Enums.ContactReportRole = {
  EPCRA_CA_OPERATOR: 'EPCRA_CA_OPERATOR',
  EPCRA_CA_OWNER: 'EPCRA_CA_OWNER',
  EPCRA_CA_PROPERTY_OWNER: 'EPCRA_CA_PROPERTY_OWNER',
  EPCRA_CA_TANK_OPERATOR: 'EPCRA_CA_TANK_OPERATOR',
  EPCRA_CA_TANK_OWNER: 'EPCRA_CA_TANK_OWNER',
  EPCRA_CHEMICAL_CARRIER: 'EPCRA_CHEMICAL_CARRIER',
  EPCRA_EMERGENCY_CONTACT: 'EPCRA_EMERGENCY_CONTACT',
  EPCRA_EMERGENCY_COORDINATOR: 'EPCRA_EMERGENCY_COORDINATOR',
  EPCRA_EMERGENCY_EQUIPMENT_CONTACT: 'EPCRA_EMERGENCY_EQUIPMENT_CONTACT',
  EPCRA_OWNER_OPERATOR: 'EPCRA_OWNER_OPERATOR',
  EPCRA_TIER_II_CONTACT: 'EPCRA_TIER_II_CONTACT',
  EPCRA_BILLING: 'EPCRA_BILLING',
  EPCRA_T2M_PARENT_COMPANY: 'EPCRA_T2M_PARENT_COMPANY',
  EPCRA_T2M_DIRECT_SITE_COMMUNICATION: 'EPCRA_T2M_DIRECT_SITE_COMMUNICATION',
  EPCRA_REGIONAL_ENVIRONMENTAL_CONTACT: 'EPCRA_REGIONAL_ENVIRONMENTAL_CONTACT',
  GENERAL: 'GENERAL',
  RCRA_AUTHORIZED_REPRESENTATIVE: 'RCRA_AUTHORIZED_REPRESENTATIVE',
  RCRA_BILLING_CONTACT: 'RCRA_BILLING_CONTACT',
  RCRA_HURRICANE_POINT_OF_CONTACT: 'RCRA_HURRICANE_POINT_OF_CONTACT',
  RCRA_OWNER: 'RCRA_OWNER',
  RCRA_OPERATOR: 'RCRA_OPERATOR',
  RCRA_REAL_PROPERTY_OWNER: 'RCRA_REAL_PROPERTY_OWNER',
  RCRA_SITE_CONTACT: 'RCRA_SITE_CONTACT',
  RCRA_SITE_MANAGER: 'RCRA_SITE_MANAGER'
};

exports.FacilityPilotProgramStatus = exports.$Enums.FacilityPilotProgramStatus = {
  Ready: 'Ready',
  NotReady: 'NotReady'
};

exports.ThresholdReason = exports.$Enums.ThresholdReason = {
  Federal: 'Federal',
  State: 'State',
  FacilityEHSTotal: 'FacilityEHSTotal'
};

exports.InsideOutside = exports.$Enums.InsideOutside = {
  INSIDE: 'INSIDE',
  OUTSIDE: 'OUTSIDE'
};

exports.ThresholdResultJurisdictionType = exports.$Enums.ThresholdResultJurisdictionType = {
  FEDERAL: 'FEDERAL',
  STATE: 'STATE',
  LOCAL: 'LOCAL'
};

exports.ThresholdResultType = exports.$Enums.ThresholdResultType = {
  SECTION_302_TPQ_HIGH: 'SECTION_302_TPQ_HIGH',
  SECTION_302_TPQ_LOW: 'SECTION_302_TPQ_LOW',
  SECTION_302: 'SECTION_302',
  SECTION_312_TPQ_HIGH: 'SECTION_312_TPQ_HIGH',
  SECTION_312_TPQ_LOW: 'SECTION_312_TPQ_LOW',
  SECTION_312: 'SECTION_312',
  SECTION_302_PBB_GROUP: 'SECTION_302_PBB_GROUP',
  SECTION_312_PBB_GROUP: 'SECTION_312_PBB_GROUP',
  AZ_GILBERT: 'AZ_GILBERT',
  CA_LEPCS_ETIOLOGIC_AGENTS: 'CA_LEPCS_ETIOLOGIC_AGENTS',
  CA_LEPCS_EXPLOSIVES: 'CA_LEPCS_EXPLOSIVES',
  CA_LEPCS_HAZARDOUS_MATERIALS: 'CA_LEPCS_HAZARDOUS_MATERIALS',
  CA_LEPCS_MANUFACTURED_NANOPARTICLES: 'CA_LEPCS_MANUFACTURED_NANOPARTICLES',
  CA_LEPCS_NRC: 'CA_LEPCS_NRC',
  CA_LEPCS_TOXIC_GASES: 'CA_LEPCS_TOXIC_GASES',
  CA_LEPCS_WASTE: 'CA_LEPCS_WASTE',
  CA_LIVERMORE_PLEASANTON_ACUTE_TOXICITY_GASES: 'CA_LIVERMORE_PLEASANTON_ACUTE_TOXICITY_GASES',
  CA_LIVERMORE_PLEASANTON_FIRE_HAZARD: 'CA_LIVERMORE_PLEASANTON_FIRE_HAZARD',
  CA_ALWAYS_REPORTING: 'CA_ALWAYS_REPORTING',
  CA_STATE: 'CA_STATE',
  CA_IFC_HAZARDS: 'CA_IFC_HAZARDS',
  DE_STATE: 'DE_STATE',
  LA_STATE: 'LA_STATE',
  MD_MONTGOMERY: 'MD_MONTGOMERY',
  MO_EXPLOSIVES: 'MO_EXPLOSIVES',
  NC_COUNTY: 'NC_COUNTY',
  NC_RTK_STATE_WIDE: 'NC_RTK_STATE_WIDE',
  NJ_EHS: 'NJ_EHS',
  NV_COMBUSTIBLE_LIQUIDS: 'NV_COMBUSTIBLE_LIQUIDS',
  NV_CORROSIVE_GASES: 'NV_CORROSIVE_GASES',
  NV_CORROSIVE_LIQUIDS: 'NV_CORROSIVE_LIQUIDS',
  NV_CORROSIVE_SOLIDS: 'NV_CORROSIVE_SOLIDS',
  NV_CRYOGENIC_LIQUIDS: 'NV_CRYOGENIC_LIQUIDS',
  NV_FLAMMABLE_GASES: 'NV_FLAMMABLE_GASES',
  NV_FLAMMABLE_LIQUIDS: 'NV_FLAMMABLE_LIQUIDS',
  NV_FLAMMABLE_SOLIDS: 'NV_FLAMMABLE_SOLIDS',
  NV_HIGHLY_TOXIC: 'NV_HIGHLY_TOXIC',
  NV_ORGANIC_PEROXIDE_LIQUIDS: 'NV_ORGANIC_PEROXIDE_LIQUIDS',
  NV_ORGANIC_PEROXIDE_SOLIDS: 'NV_ORGANIC_PEROXIDE_SOLIDS',
  NV_OXIDIZING_GASES: 'NV_OXIDIZING_GASES',
  NV_OXIDIZING_LIQUIDS: 'NV_OXIDIZING_LIQUIDS',
  NV_OXIDIZING_SOLIDS: 'NV_OXIDIZING_SOLIDS',
  NV_PYROPHORIC: 'NV_PYROPHORIC',
  NV_TOXIC_GASES: 'NV_TOXIC_GASES',
  NV_TOXIC_LIQUIDS: 'NV_TOXIC_LIQUIDS',
  NV_TOXIC_SOLIDS: 'NV_TOXIC_SOLIDS',
  NV_UNSTABLE_LIQUIDS: 'NV_UNSTABLE_LIQUIDS',
  NV_UNSTABLE_SOLIDS: 'NV_UNSTABLE_SOLIDS',
  NV_WATER_REACTIVE_LIQUIDS: 'NV_WATER_REACTIVE_LIQUIDS',
  NV_WATER_REACTIVE_SOLIDS: 'NV_WATER_REACTIVE_SOLIDS',
  NV_GAS_STATION: 'NV_GAS_STATION',
  NY_NYC: 'NY_NYC',
  NY_NYC_CAS: 'NY_NYC_CAS',
  OR_RADIOACTIVE: 'OR_RADIOACTIVE',
  OR_STATE: 'OR_STATE',
  OR_TOXICS_EXPLOSIVES: 'OR_TOXICS_EXPLOSIVES',
  VT_CARCINOGENIC: 'VT_CARCINOGENIC',
  VT_EXPLOSIVES: 'VT_EXPLOSIVES',
  VT_STATE: 'VT_STATE',
  AK_DOT_PLACARD: 'AK_DOT_PLACARD',
  AK_COMPRESSED_GAS: 'AK_COMPRESSED_GAS',
  AK_ANCHORAGE_STANDARD: 'AK_ANCHORAGE_STANDARD',
  AK_ANCHORAGE_HAZARDOUS_WASTE: 'AK_ANCHORAGE_HAZARDOUS_WASTE',
  AK_ANCHORAGE_ACUTE_HAZARDOUS_WASTE: 'AK_ANCHORAGE_ACUTE_HAZARDOUS_WASTE',
  AK_ANCHORAGE_NFPA_COMPRESSED_GAS_LOW: 'AK_ANCHORAGE_NFPA_COMPRESSED_GAS_LOW',
  AK_ANCHORAGE_NFPA_COMPRESSED_GAS_HIGH: 'AK_ANCHORAGE_NFPA_COMPRESSED_GAS_HIGH',
  AK_ANCHORAGE_CONSUMER_COMMODITY: 'AK_ANCHORAGE_CONSUMER_COMMODITY'
};

exports.EchoQuarterlyHistory = exports.$Enums.EchoQuarterlyHistory = {
  SIGNIFICANT_NONCOMPLIANCE: 'SIGNIFICANT_NONCOMPLIANCE',
  VIOLATION: 'VIOLATION',
  NO_VIOLATION: 'NO_VIOLATION',
  UNKNOWN: 'UNKNOWN',
  INACTIVE: 'INACTIVE'
};

exports.FacilityTypeCode = exports.$Enums.FacilityTypeCode = {
  COUNTY_GOVERNMENT: 'COUNTY_GOVERNMENT',
  CORPORATION: 'CORPORATION',
  MUNICIPALITY: 'MUNICIPALITY',
  DISTRICT: 'DISTRICT',
  FEDERAL_FACILITY: 'FEDERAL_FACILITY',
  GOVERNMENT_OWNED_CONTRACTOR_OPERATED: 'GOVERNMENT_OWNED_CONTRACTOR_OPERATED',
  INDIVIDUAL: 'INDIVIDUAL',
  MUNICIPAL_OR_WATER_DISTRICT: 'MUNICIPAL_OR_WATER_DISTRICT',
  MIXED_OWNERSHIP: 'MIXED_OWNERSHIP',
  NON_GOVERNMENT: 'NON_GOVERNMENT',
  PRIVATELY_OWNED_FACILITY: 'PRIVATELY_OWNED_FACILITY',
  SCHOOL_DISTRICT: 'SCHOOL_DISTRICT',
  STATE_GOVERNMENT: 'STATE_GOVERNMENT',
  TRIBAL_GOVERNMENT: 'TRIBAL_GOVERNMENT',
  UNKNOWN: 'UNKNOWN'
};

exports.FacilityTypeIndicator = exports.$Enums.FacilityTypeIndicator = {
  PUBLICLY_OWNED_TREATMENT_WORKS: 'PUBLICLY_OWNED_TREATMENT_WORKS',
  NON_PUBLICLY_OWNED_TREATMENT_WORKS: 'NON_PUBLICLY_OWNED_TREATMENT_WORKS',
  FEDERAL_FACILITY: 'FEDERAL_FACILITY'
};

exports.PermitTypeCode = exports.$Enums.PermitTypeCode = {
  NPDES_INDIVIDUAL_PERMIT: 'NPDES_INDIVIDUAL_PERMIT',
  NPDES_MASTER_GENERAL_PERMIT: 'NPDES_MASTER_GENERAL_PERMIT',
  GENERAL_PERMIT_COVERED_FACILITY: 'GENERAL_PERMIT_COVERED_FACILITY',
  STATE_ISSUED_MASTER_GENERAL_PERMIT_NON_NPDES: 'STATE_ISSUED_MASTER_GENERAL_PERMIT_NON_NPDES',
  INDIVIDUAL_IU_PERMIT_NON_NPDES: 'INDIVIDUAL_IU_PERMIT_NON_NPDES',
  INDIVIDUAL_STATE_ISSUED_PERMIT_NON_NPDES: 'INDIVIDUAL_STATE_ISSUED_PERMIT_NON_NPDES',
  ASSOCIATED_PERMIT_RECORD: 'ASSOCIATED_PERMIT_RECORD',
  UNPERMITTED_FACILITY: 'UNPERMITTED_FACILITY'
};

exports.MajorMinorStatusFlag = exports.$Enums.MajorMinorStatusFlag = {
  MAJOR: 'MAJOR',
  NON_MAJOR: 'NON_MAJOR'
};

exports.PermitStatusCode = exports.$Enums.PermitStatusCode = {
  EFFECTIVE: 'EFFECTIVE',
  ADMINISTRATIVELY_CONTINUED: 'ADMINISTRATIVELY_CONTINUED',
  EXPIRED: 'EXPIRED',
  NOT_NEEDED: 'NOT_NEEDED',
  PENDING: 'PENDING',
  RETIRED: 'RETIRED',
  TERMINATED: 'TERMINATED'
};

exports.AgencyTypeCode = exports.$Enums.AgencyTypeCode = {
  STATE: 'STATE',
  MUNICIPAL: 'MUNICIPAL',
  COUNTY: 'COUNTY',
  REGIONAL: 'REGIONAL',
  US_EPA: 'US_EPA',
  EPA_CONTRACTOR: 'EPA_CONTRACTOR',
  OTHER_EPA: 'OTHER_EPA',
  INTERSTATE: 'INTERSTATE',
  LOCAL: 'LOCAL',
  OTHER_FEDERAL: 'OTHER_FEDERAL',
  STATE_CONTRACTOR: 'STATE_CONTRACTOR',
  OTHER_STATE: 'OTHER_STATE',
  TRIBAL: 'TRIBAL',
  UNKNOWN_FROM_CONVERSION: 'UNKNOWN_FROM_CONVERSION',
  SENIOR_ENVIRONMENTAL_EMPLOYMENT_SEE_INSPECTOR: 'SENIOR_ENVIRONMENTAL_EMPLOYMENT_SEE_INSPECTOR',
  OTHER: 'OTHER',
  CONTRACTOR: 'CONTRACTOR'
};

exports.PretreatmentIndicatorCode = exports.$Enums.PretreatmentIndicatorCode = {
  COVERED: 'COVERED',
  EPA: 'EPA',
  REQUIRED_AND_DEVELOPING: 'REQUIRED_AND_DEVELOPING',
  STATE: 'STATE',
  APPROVED: 'APPROVED'
};

exports.HlrncCode = exports.$Enums.HlrncCode = {
  SNC_COMPLIANCE_PERMIT_SCHEDULE_VIOLATIONS: 'SNC_COMPLIANCE_PERMIT_SCHEDULE_VIOLATIONS',
  SNC_EFFLUENT_MONTHLY_AVERAGE_LIMIT: 'SNC_EFFLUENT_MONTHLY_AVERAGE_LIMIT',
  SNC_EFFLUENT_NON_MONTHLY_AVERAGE_LIMIT: 'SNC_EFFLUENT_NON_MONTHLY_AVERAGE_LIMIT',
  SNC_COMPLIANCE_PERMIT_SCHEDULE_REPORTING: 'SNC_COMPLIANCE_PERMIT_SCHEDULE_REPORTING',
  SNC_FAILURE_TO_REPORT_DMR_NOT_RECEIVED: 'SNC_FAILURE_TO_REPORT_DMR_NOT_RECEIVED',
  FAILURE_TO_REPORT_DMR_NOT_RECEIVED: 'FAILURE_TO_REPORT_DMR_NOT_RECEIVED',
  REPORTABLE_NONCOMPLIANCE: 'REPORTABLE_NONCOMPLIANCE',
  RESOLVED_PENDING: 'RESOLVED_PENDING',
  RESOLVED_PENDING_MANUAL: 'RESOLVED_PENDING_MANUAL',
  RESOLVED: 'RESOLVED',
  NON_RNC_VIOLATIONS: 'NON_RNC_VIOLATIONS',
  UNDETERMINED: 'UNDETERMINED'
};

exports.RcraInfoSourceType = exports.$Enums.RcraInfoSourceType = {
  PART_A: 'PART_A',
  REPORT_UPDATE_WITH_NOTIFICATION: 'REPORT_UPDATE_WITH_NOTIFICATION',
  DEACTIVATION: 'DEACTIVATION',
  EMERGENCY: 'EMERGENCY',
  IMPLEMENTER: 'IMPLEMENTER',
  ELECTRONIC_MANIFEST_BROKER: 'ELECTRONIC_MANIFEST_BROKER',
  NOTIFICATION: 'NOTIFICATION',
  REPORT: 'REPORT',
  TEMPORARY: 'TEMPORARY'
};

exports.RcraInfoNonNotifier = exports.$Enums.RcraInfoNonNotifier = {
  NON_NOTIFIER_DETERMINED_TO_BE_EXEMPT: 'NON_NOTIFIER_DETERMINED_TO_BE_EXEMPT',
  FORMER_NON_NOTIFIER: 'FORMER_NON_NOTIFIER',
  NON_NOTIFIER: 'NON_NOTIFIER'
};

exports.RcraInfoAccessibility = exports.$Enums.RcraInfoAccessibility = {
  SITE_IN_BANKRUPTCY: 'SITE_IN_BANKRUPTCY',
  RESPONSIBILITIES_TRANSFERRED_TO_CERCLA: 'RESPONSIBILITIES_TRANSFERRED_TO_CERCLA',
  RESPONSIBLE_PARTIES_HAVE_FLED_THE_COUNTRY: 'RESPONSIBLE_PARTIES_HAVE_FLED_THE_COUNTRY',
  SITE_IN_LITIGATION: 'SITE_IN_LITIGATION'
};

exports.RcraInfoLandType = exports.$Enums.RcraInfoLandType = {
  COUNTY: 'COUNTY',
  DISTRICT: 'DISTRICT',
  FEDERAL: 'FEDERAL',
  TRIBAL: 'TRIBAL',
  MUNICIPAL: 'MUNICIPAL',
  OTHER: 'OTHER',
  PRIVATE: 'PRIVATE',
  STATE: 'STATE'
};

exports.RcraInfoFederalWasteGeneratorStatus = exports.$Enums.RcraInfoFederalWasteGeneratorStatus = {
  LARGE_QUANTITY_GENERATOR: 'LARGE_QUANTITY_GENERATOR',
  SMALL_QUANTITY_GENERATOR: 'SMALL_QUANTITY_GENERATOR',
  VERY_SMALL_QUANTITY_GENERATOR: 'VERY_SMALL_QUANTITY_GENERATOR',
  NOT_A_GENERATOR: 'NOT_A_GENERATOR',
  PENDING: 'PENDING',
  UNDETERMINED: 'UNDETERMINED'
};

exports.RcraInfoDataOrigin = exports.$Enums.RcraInfoDataOrigin = {
  RCRAINFO_INDUSTRY_APPLICATION: 'RCRAINFO_INDUSTRY_APPLICATION',
  RCRAINFO_BR_LOAD_UTILITY: 'RCRAINFO_BR_LOAD_UTILITY',
  DATA_ENTRY: 'DATA_ENTRY',
  EMERGENCY: 'EMERGENCY',
  EMANIFEST: 'EMANIFEST',
  MANUAL_LOAD: 'MANUAL_LOAD',
  MYRCRAID: 'MYRCRAID',
  TRANSLATION: 'TRANSLATION',
  UTILITY: 'UTILITY'
};

exports.RcraInfoOwnerOperatorIndicator = exports.$Enums.RcraInfoOwnerOperatorIndicator = {
  CURRENT_OWNER: 'CURRENT_OWNER',
  CURRENT_OPERATOR: 'CURRENT_OPERATOR',
  PREVIOUS_OWNER: 'PREVIOUS_OWNER',
  PREVIOUS_OPERATOR: 'PREVIOUS_OPERATOR'
};

exports.WasteClassification = exports.$Enums.WasteClassification = {
  RCRA_ACUTELY_HAZARDOUS: 'RCRA_ACUTELY_HAZARDOUS',
  RCRA_HAZARDOUS: 'RCRA_HAZARDOUS',
  STATE_REGULATED: 'STATE_REGULATED',
  NONHAZARDOUS: 'NONHAZARDOUS'
};

exports.WasteManifestSource = exports.$Enums.WasteManifestSource = {
  eManifest: 'eManifest',
  Vendor: 'Vendor'
};

exports.WasteManifestIngestSource = exports.$Enums.WasteManifestIngestSource = {
  BrowserAutomation: 'BrowserAutomation',
  CSVImport: 'CSVImport',
  Public: 'Public',
  RCRAInfoAPI: 'RCRAInfoAPI'
};

exports.JobStatus = exports.$Enums.JobStatus = {
  QUEUED: 'QUEUED',
  DISPATCHED: 'DISPATCHED',
  PROVISIONING_ECS_TASK: 'PROVISIONING_ECS_TASK',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  FAILED_MAY_AUTO_RETRY: 'FAILED_MAY_AUTO_RETRY',
  FAILED_NEEDS_HUMAN: 'FAILED_NEEDS_HUMAN',
  FAILED_QUALITY_CONTROL_CHECK: 'FAILED_QUALITY_CONTROL_CHECK',
  FAILED_PROVISIONING_ECS_TASK: 'FAILED_PROVISIONING_ECS_TASK',
  AWAITING_MANUAL_INTERVENTION: 'AWAITING_MANUAL_INTERVENTION',
  SHOULD_CANCEL: 'SHOULD_CANCEL',
  CANCELLING: 'CANCELLING',
  CANCELLED: 'CANCELLED',
  PROMOTED: 'PROMOTED',
  SENT: 'SENT',
  PROVISIONING: 'PROVISIONING'
};

exports.JobTask = exports.$Enums.JobTask = {
  ASMARK_INGEST: 'ASMARK_INGEST',
  DATA_PIPELINE: 'DATA_PIPELINE',
  DEMO_DATA: 'DEMO_DATA',
  EMAIL_DIGESTS: 'EMAIL_DIGESTS',
  FILE_EXTRACTION: 'FILE_EXTRACTION',
  GENERATE_PDF: 'GENERATE_PDF',
  GENERATE_PDF_ECS: 'GENERATE_PDF_ECS',
  INSIGHTS_CONNECTOR: 'INSIGHTS_CONNECTOR',
  SEND_CHECK: 'SEND_CHECK',
  STAFF_REPORT: 'STAFF_REPORT',
  PROCESS_MANIFESTS: 'PROCESS_MANIFESTS',
  WEB_AUTOMATION: 'WEB_AUTOMATION',
  CHEMICAL_AGGREGATION: 'CHEMICAL_AGGREGATION',
  PROMOTE_DRAFT_REPORT: 'PROMOTE_DRAFT_REPORT',
  ONE_SCHEMA_FILE_UPLOAD: 'ONE_SCHEMA_FILE_UPLOAD',
  EXPORT_DATA: 'EXPORT_DATA',
  VALIDATE_TENANT: 'VALIDATE_TENANT',
  BULK_VERIFY_AND_SUBMIT_REPORTS: 'BULK_VERIFY_AND_SUBMIT_REPORTS',
  BULK_RESET_TIER_II_REPORTS: 'BULK_RESET_TIER_II_REPORTS',
  BULK_SEND_SUBMISSIONS_TO_REVIEWERS: 'BULK_SEND_SUBMISSIONS_TO_REVIEWERS',
  TIER_2_SUBMIT: 'TIER_2_SUBMIT',
  SIGN_PDF: 'SIGN_PDF',
  CREATE_TIER_II_DELIVERABLES: 'CREATE_TIER_II_DELIVERABLES',
  SLACK: 'SLACK',
  SEND_EMAIL: 'SEND_EMAIL',
  SEND_MAIL: 'SEND_MAIL',
  ADD_DOCUMENT: 'ADD_DOCUMENT',
  CREATE_TIER_II_DELIVERABLES_LAMBDA: 'CREATE_TIER_II_DELIVERABLES_LAMBDA',
  PRESUBMISSION: 'PRESUBMISSION',
  ZIP: 'ZIP',
  E_MANIFEST_API: 'E_MANIFEST_API',
  E_MANIFEST_SITE_ACCESS: 'E_MANIFEST_SITE_ACCESS',
  DOCS_TO_SINGLE_PDF: 'DOCS_TO_SINGLE_PDF',
  DATABASE_BENCHMARK: 'DATABASE_BENCHMARK',
  ERROR_CLUSTERING: 'ERROR_CLUSTERING',
  CREATE_SUBMISSION_TASKS: 'CREATE_SUBMISSION_TASKS',
  DOWNLOAD_MISSING_BOLDSIGN_PROOF_DOCUMENTS: 'DOWNLOAD_MISSING_BOLDSIGN_PROOF_DOCUMENTS',
  DOCUMENT_AI_ENRICHMENT: 'DOCUMENT_AI_ENRICHMENT',
  FACILITY_EMBEDDING: 'FACILITY_EMBEDDING',
  SUGGEST_TASKS: 'SUGGEST_TASKS',
  SALESFORCE_TENANT_SYNC: 'SALESFORCE_TENANT_SYNC'
};

exports.JobRunsOn = exports.$Enums.JobRunsOn = {
  ECS: 'ECS',
  LAMBDA: 'LAMBDA'
};

exports.WebAutomationAction = exports.$Enums.WebAutomationAction = {
  acquireLock: 'acquireLock',
  closeDraftReport: 'closeDraftReport',
  collectEvidenceOfCompletion: 'collectEvidenceOfCompletion',
  downloadReport: 'downloadReport',
  deleteLock: 'deleteLock',
  eManifestCSVDownload: 'eManifestCSVDownload',
  eManifestDataDownload: 'eManifestDataDownload',
  extractChemicalDatabase: 'extractChemicalDatabase',
  extractData: 'extractData',
  extractStateIDs: 'extractStateIDs',
  extractHazardousMaterialsPermit: 'extractHazardousMaterialsPermit',
  finalizeSubmission: 'finalizeSubmission',
  getFacilitiesList: 'getFacilitiesList',
  inputData: 'inputData',
  inputDataRevision: 'inputDataRevision',
  inputDataLepc: 'inputDataLepc',
  portalSubmissionStatus: 'portalSubmissionStatus',
  rcra870012: 'rcra870012',
  rcra870013: 'rcra870013',
  rcraEvq: 'rcraEvq',
  rcraVerifyCredentials: 'rcraVerifyCredentials',
  scrapeDistrictInfo: 'scrapeDistrictInfo',
  verifyCredentials: 'verifyCredentials',
  verify870012Submission: 'verify870012Submission'
};

exports.WebAutomationCollectEvidenceOfCompletionActions = exports.$Enums.WebAutomationCollectEvidenceOfCompletionActions = {
  completion: 'completion',
  chemicalCount: 'chemicalCount'
};

exports.LockType = exports.$Enums.LockType = {
  BulkMirror: 'BulkMirror',
  Cohort: 'Cohort',
  Credential: 'Credential',
  FacilityForWasteManifest: 'FacilityForWasteManifest',
  Job: 'Job',
  Report: 'Report',
  WorkflowManager: 'WorkflowManager'
};

exports.OneSchemaImportStatus = exports.$Enums.OneSchemaImportStatus = {
  INITIALIZED: 'INITIALIZED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.OneSchemaImportProcessingMethod = exports.$Enums.OneSchemaImportProcessingMethod = {
  WEBHOOK: 'WEBHOOK',
  LAMBDA: 'LAMBDA'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  AWAITING_INVOICE: 'AWAITING_INVOICE',
  PENDING: 'PENDING',
  PAID: 'PAID',
  NO_PAYMENT: 'NO_PAYMENT',
  CANCELLED: 'CANCELLED',
  VOID: 'VOID',
  FAILURE: 'FAILURE'
};

exports.PaymentMethod = exports.$Enums.PaymentMethod = {
  CHECK: 'CHECK',
  CREDIT_CARD: 'CREDIT_CARD',
  ACH: 'ACH',
  NO_PAYMENT: 'NO_PAYMENT'
};

exports.ReconciliationStatus = exports.$Enums.ReconciliationStatus = {
  UNRECONCILED: 'UNRECONCILED',
  RECONCILED: 'RECONCILED',
  PROBLEM: 'PROBLEM'
};

exports.TankOwnerType = exports.$Enums.TankOwnerType = {
  LOCAL_AGENCY: 'LOCAL_AGENCY',
  COUNTY_AGENCY: 'COUNTY_AGENCY',
  STATE_AGENCY: 'STATE_AGENCY',
  FEDERAL_AGENCY: 'FEDERAL_AGENCY',
  NON_GOVERNMENT: 'NON_GOVERNMENT'
};

exports.PortalType = exports.$Enums.PortalType = {
  STATE: 'STATE',
  LEPC: 'LEPC',
  CITY: 'CITY',
  FEDERAL: 'FEDERAL'
};

exports.ChemicalDbRequirement = exports.$Enums.ChemicalDbRequirement = {
  EHS_ONLY: 'EHS_ONLY',
  ALL: 'ALL',
  NO: 'NO'
};

exports.SnapshotType = exports.$Enums.SnapshotType = {
  TIER_II_REPORT: 'TIER_II_REPORT'
};

exports.StorageQuadrant = exports.$Enums.StorageQuadrant = {
  N: 'N',
  S: 'S',
  E: 'E',
  W: 'W',
  NE: 'NE',
  SE: 'SE',
  NW: 'NW',
  SW: 'SW',
  C: 'C',
  V: 'V'
};

exports.SubmissionType = exports.$Enums.SubmissionType = {
  WASTE_BIENNIAL: 'WASTE_BIENNIAL',
  BIENNIAL_REPORT: 'BIENNIAL_REPORT',
  AL_ANNUAL_NOTIFICATION: 'AL_ANNUAL_NOTIFICATION',
  AZ_REGISTRATION_REPORT: 'AZ_REGISTRATION_REPORT',
  AZ_GENERATION_REPORT: 'AZ_GENERATION_REPORT',
  ANNUAL_REPORT: 'ANNUAL_REPORT',
  CA_EVQ: 'CA_EVQ',
  CO_SQG_SELF_CERTIFICATION: 'CO_SQG_SELF_CERTIFICATION',
  ID_ANNUAL_REPORT: 'ID_ANNUAL_REPORT',
  IA_ANNUAL_REPORT: 'IA_ANNUAL_REPORT',
  KS_ANNUAL_REPORT: 'KS_ANNUAL_REPORT',
  ME_ANNUAL_REPORT: 'ME_ANNUAL_REPORT',
  KY_ANNUAL_REPORT: 'KY_ANNUAL_REPORT',
  KY_REGISTRATION_REPORT: 'KY_REGISTRATION_REPORT',
  MN_MPCA_LICENSE_RENEWAL: 'MN_MPCA_LICENSE_RENEWAL',
  MN_COUNTY_LICENSE_RENEWALS: 'MN_COUNTY_LICENSE_RENEWALS',
  MN_HENNEPIN_COUNTY_LICENSE_RENEWAL: 'MN_HENNEPIN_COUNTY_LICENSE_RENEWAL',
  MO_ANNUAL_REPORT: 'MO_ANNUAL_REPORT',
  MT_ANNUAL_REPORT: 'MT_ANNUAL_REPORT',
  NH_QUARTERLY_ACTIVITY_REPORT: 'NH_QUARTERLY_ACTIVITY_REPORT',
  NH_TRIENNIAL_REPORT: 'NH_TRIENNIAL_REPORT',
  OR_ANNUAL_REPORT: 'OR_ANNUAL_REPORT',
  SC_QUARTERLY_REPORT: 'SC_QUARTERLY_REPORT',
  SC_SQG_ANNUAL_NOTIFICATION: 'SC_SQG_ANNUAL_NOTIFICATION',
  TX_ANNUAL_WASTE_SUMMARY: 'TX_ANNUAL_WASTE_SUMMARY',
  WI_ANNUAL_REPORT: 'WI_ANNUAL_REPORT',
  DC_ANNUAL_REPORT: 'DC_ANNUAL_REPORT',
  AZ_P2_ANNUAL_PROGRESS_REPORT: 'AZ_P2_ANNUAL_PROGRESS_REPORT',
  MS_P2_ANNUAL_PROGRESS_REPORT: 'MS_P2_ANNUAL_PROGRESS_REPORT',
  NY_HAZARDOUS_WASTE_REDUCTION_PLAN: 'NY_HAZARDOUS_WASTE_REDUCTION_PLAN',
  TX_P2_ANNUAL_PROGRESS_REPORT: 'TX_P2_ANNUAL_PROGRESS_REPORT',
  WA_P2_ANNUAL_PROGRESS_REPORT: 'WA_P2_ANNUAL_PROGRESS_REPORT',
  GA_BIENNIAL_HAZARDOUS_WASTE_REDUCTION_PLAN: 'GA_BIENNIAL_HAZARDOUS_WASTE_REDUCTION_PLAN',
  NY_QUARTERLY_WASTE_TAXES: 'NY_QUARTERLY_WASTE_TAXES',
  WV_HW_GENERATOR_FEES: 'WV_HW_GENERATOR_FEES',
  HAZARDOUS_WASTE_NOTIFICATION: 'HAZARDOUS_WASTE_NOTIFICATION',
  FL_WASTE_NOTIFICATION: 'FL_WASTE_NOTIFICATION',
  NE_WASTE_NOTIFICATION: 'NE_WASTE_NOTIFICATION',
  TX_WASTE_NOTIFICATION: 'TX_WASTE_NOTIFICATION',
  NH_WASTE_NOTIFICATION: 'NH_WASTE_NOTIFICATION',
  CA_STATE_WASTE_NOTIFICATION: 'CA_STATE_WASTE_NOTIFICATION',
  KS_WASTE_NOTIFICATION: 'KS_WASTE_NOTIFICATION',
  KY_WASTE_NOTIFICATION: 'KY_WASTE_NOTIFICATION',
  LA_WASTE_NOTIFICATION: 'LA_WASTE_NOTIFICATION',
  MI_WASTE_NOTIFICATION: 'MI_WASTE_NOTIFICATION',
  MN_WASTE_NOTIFICATION: 'MN_WASTE_NOTIFICATION',
  MO_WASTE_NOTIFICATION: 'MO_WASTE_NOTIFICATION',
  OR_WASTE_NOTIFICATION: 'OR_WASTE_NOTIFICATION',
  PA_WASTE_NOTIFICATION: 'PA_WASTE_NOTIFICATION',
  TN_WASTE_NOTIFICATION: 'TN_WASTE_NOTIFICATION',
  OTHER: 'OTHER'
};

exports.SubmissionStatus = exports.$Enums.SubmissionStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  ENCAMP_INITIAL_REVIEW: 'ENCAMP_INITIAL_REVIEW',
  IN_REVIEW: 'IN_REVIEW',
  PROCESSING_SUBMISSION: 'PROCESSING_SUBMISSION',
  FILING_COMPLETE: 'FILING_COMPLETE',
  NOT_REPORTING: 'NOT_REPORTING'
};

exports.RequirementStatus = exports.$Enums.RequirementStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED'
};

exports.SubmissionMethod = exports.$Enums.SubmissionMethod = {
  RCRAINFO_BIENNIAL_REPORTING_MODULE: 'RCRAINFO_BIENNIAL_REPORTING_MODULE',
  RCRAINFO_MYRCRAID_MODULE: 'RCRAINFO_MYRCRAID_MODULE',
  RCRAINFO_ANNUAL_REPORTING_MODULE: 'RCRAINFO_ANNUAL_REPORTING_MODULE',
  AZ_MYDEQ_PORTAL: 'AZ_MYDEQ_PORTAL',
  CA_EVQ_MODULE: 'CA_EVQ_MODULE',
  CO_SELF_CERT_PORTAL: 'CO_SELF_CERT_PORTAL',
  ID_PORTAL: 'ID_PORTAL',
  KS_KEIMS_PORTAL: 'KS_KEIMS_PORTAL',
  KY_GATEWAY_PORTAL: 'KY_GATEWAY_PORTAL',
  MPCA_E_SERVICES: 'MPCA_E_SERVICES',
  COUNTY_PDFS_OR_PORTALS: 'COUNTY_PDFS_OR_PORTALS',
  HENNEPIN_HAZWASTE_PORTAL: 'HENNEPIN_HAZWASTE_PORTAL',
  MO_MOGEMS: 'MO_MOGEMS',
  OR_PORTAL: 'OR_PORTAL',
  TX_STEERS_PORTAL: 'TX_STEERS_PORTAL',
  WI_DNR_SWITCHBOARD: 'WI_DNR_SWITCHBOARD',
  DC_SQG_SELF_CERTIFICATION_PORTAL: 'DC_SQG_SELF_CERTIFICATION_PORTAL',
  WA_SAWS_TURBOPLAN: 'WA_SAWS_TURBOPLAN',
  PAPER_FORM: 'PAPER_FORM'
};

exports.ReviewMode = exports.$Enums.ReviewMode = {
  SEQUENTIAL: 'SEQUENTIAL',
  PARALLEL: 'PARALLEL'
};

exports.SignatureType = exports.$Enums.SignatureType = {
  NONE: 'NONE',
  DIGITAL: 'DIGITAL',
  WET_INK: 'WET_INK'
};

exports.SubmissionSource = exports.$Enums.SubmissionSource = {
  USER: 'USER',
  SYSTEM: 'SYSTEM'
};

exports.DocumentSource = exports.$Enums.DocumentSource = {
  CUSTOMER: 'CUSTOMER',
  TPM: 'TPM'
};

exports.SubmissionDocumentType = exports.$Enums.SubmissionDocumentType = {
  SUBMISSION: 'SUBMISSION',
  SIGNED_SUBMISSION: 'SIGNED_SUBMISSION',
  REJECTED_SUBMISSION: 'REJECTED_SUBMISSION',
  ATTACHMENT: 'ATTACHMENT'
};

exports.ReviewerStatus = exports.$Enums.ReviewerStatus = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
};

exports.SignatureStatus = exports.$Enums.SignatureStatus = {
  NONE: 'NONE',
  NOT_COMPLETED: 'NOT_COMPLETED',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
  REVOKED: 'REVOKED',
  EXPIRED: 'EXPIRED',
  SENT: 'SENT'
};

exports.TagIcon = exports.$Enums.TagIcon = {
  BADGE_CHECK: 'BADGE_CHECK',
  FOLDER_OPEN: 'FOLDER_OPEN',
  RADIATION_ALT: 'RADIATION_ALT',
  RECYCLE: 'RECYCLE',
  TRASH: 'TRASH',
  USER_HARD_HAT: 'USER_HARD_HAT',
  WATER: 'WATER',
  WIND: 'WIND'
};

exports.TagType = exports.$Enums.TagType = {
  Document: 'Document',
  Facility: 'Facility',
  Task: 'Task',
  Waste: 'Waste',
  Workflow: 'Workflow'
};

exports.Frequency = exports.$Enums.Frequency = {
  ONCE: 'ONCE',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY'
};

exports.TenantContactType = exports.$Enums.TenantContactType = {
  CSM: 'CSM',
  WASTE_MANAGER: 'WASTE_MANAGER',
  DATA_MANAGER: 'DATA_MANAGER',
  CUSTOMER_POC: 'CUSTOMER_POC',
  ACCOUNT_MANAGER: 'ACCOUNT_MANAGER'
};

exports.TierIIReportOrgStatus = exports.$Enums.TierIIReportOrgStatus = {
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  IN_REVIEW: 'IN_REVIEW',
  NOT_REPORTING: 'NOT_REPORTING',
  NOT_STARTED: 'NOT_STARTED',
  VERIFIED: 'VERIFIED'
};

exports.TierIIReportEncampStatus = exports.$Enums.TierIIReportEncampStatus = {
  AWAITING_VERIFICATION: 'AWAITING_VERIFICATION',
  NOT_REPORTING: 'NOT_REPORTING',
  PROCESSING: 'PROCESSING',
  FILING_COMPLETE: 'FILING_COMPLETE'
};

exports.TierIIReportKind = exports.$Enums.TierIIReportKind = {
  ANNUAL: 'ANNUAL',
  INITIAL: 'INITIAL',
  REVISION: 'REVISION',
  UPDATE: 'UPDATE'
};

exports.TierIIReportFiledBy = exports.$Enums.TierIIReportFiledBy = {
  ENCAMP: 'ENCAMP',
  OTHER: 'OTHER'
};

exports.TierIIReportStep = exports.$Enums.TierIIReportStep = {
  CHEMICALS: 'CHEMICALS',
  CHEMICAL_SUMMARY: 'CHEMICAL_SUMMARY',
  CONTACTS: 'CONTACTS',
  DOCUMENTS: 'DOCUMENTS',
  FACILITY: 'FACILITY',
  OTHER_CHEMICALS: 'OTHER_CHEMICALS',
  PRODUCTS: 'PRODUCTS',
  REGULATORY: 'REGULATORY',
  REPORT_OVERVIEW: 'REPORT_OVERVIEW',
  REVIEW: 'REVIEW',
  STATE_INFORMATION: 'STATE_INFORMATION',
  VERIFY_AND_SUBMIT: 'VERIFY_AND_SUBMIT'
};

exports.TierIIReportCAStep = exports.$Enums.TierIIReportCAStep = {
  APSAFacilityInformation: 'APSAFacilityInformation',
  AboveGroundSeparationContainmentAndMonitoringPlan: 'AboveGroundSeparationContainmentAndMonitoringPlan',
  AbovegroundPetroleumStorageActDocumentation: 'AbovegroundPetroleumStorageActDocumentation',
  EmergencyResponseContingencyPlan: 'EmergencyResponseContingencyPlan',
  EmployeeTrainingPlan: 'EmployeeTrainingPlan',
  FacilityInformation: 'FacilityInformation',
  HazardousWasteTankClosureCertificate: 'HazardousWasteTankClosureCertificate',
  OwnerStatementOfDesignatedUSTOperatorCompliance: 'OwnerStatementOfDesignatedUSTOperatorCompliance',
  RecyclableMaterialsReportDocumentation: 'RecyclableMaterialsReportDocumentation',
  SitePlan: 'SitePlan',
  USTCertificationOfFinancialResponsibility: 'USTCertificationOfFinancialResponsibility',
  USTCertificationsOfInstallationModification: 'USTCertificationsOfInstallationModification',
  USTFacilityOperatingPermitApplication: 'USTFacilityOperatingPermitApplication',
  USTLetterFromChiefFinancialOfficer: 'USTLetterFromChiefFinancialOfficer',
  USTMonitoringSitePlan: 'USTMonitoringSitePlan',
  USTOwnerOperatorWrittenAgreement: 'USTOwnerOperatorWrittenAgreement',
  USTResponsePlan: 'USTResponsePlan'
};

exports.AssignmentType = exports.$Enums.AssignmentType = {
  ASSIGNEE: 'ASSIGNEE',
  REVIEWER: 'REVIEWER'
};

exports.StatusType = exports.$Enums.StatusType = {
  encampStatus: 'encampStatus',
  organizationStatus: 'organizationStatus'
};

exports.TierIIReportUstStep = exports.$Enums.TierIIReportUstStep = {
  TankInformation: 'TankInformation',
  TankMonitoringPlan: 'TankMonitoringPlan'
};

exports.UserType = exports.$Enums.UserType = {
  STAFF_ADMIN: 'STAFF_ADMIN',
  STAFF_EMPLOYEE: 'STAFF_EMPLOYEE',
  STAFF_TEMP: 'STAFF_TEMP',
  CUSTOMER: 'CUSTOMER'
};

exports.UserStatus = exports.$Enums.UserStatus = {
  NOT_INVITED: 'NOT_INVITED',
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DISABLED: 'DISABLED'
};

exports.WasteClassificationLegacy = exports.$Enums.WasteClassificationLegacy = {
  RCRA_ACUTELY_HAZARDOUS: 'RCRA_ACUTELY_HAZARDOUS',
  RCRA_HAZARDOUS: 'RCRA_HAZARDOUS',
  STATE_REGULATED: 'STATE_REGULATED',
  UNIVERSAL: 'UNIVERSAL',
  PHARMACEUTICAL: 'PHARMACEUTICAL',
  NONHAZARDOUS: 'NONHAZARDOUS'
};

exports.EManifestWasteUnit = exports.$Enums.EManifestWasteUnit = {
  G: 'G',
  K: 'K',
  L: 'L',
  M: 'M',
  N: 'N',
  P: 'P',
  T: 'T',
  Y: 'Y'
};

exports.StateWasteClassification = exports.$Enums.StateWasteClassification = {
  HAZARDOUS: 'HAZARDOUS',
  NONHAZARDOUS: 'NONHAZARDOUS',
  ACUTELY_HAZARDOUS: 'ACUTELY_HAZARDOUS'
};

exports.ActivityStatus = exports.$Enums.ActivityStatus = {
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Error: 'Error',
  StaffCompleted: 'StaffCompleted',
  Completed: 'Completed',
  Canceled: 'Canceled',
  Queued: 'Queued'
};

exports.ExecutionPlanType = exports.$Enums.ExecutionPlanType = {
  Human: 'Human',
  Automation: 'Automation'
};

exports.Tier2SubmitValidationStatus = exports.$Enums.Tier2SubmitValidationStatus = {
  Valid: 'Valid',
  Invalid: 'Invalid',
  HasWarnings: 'HasWarnings',
  PendingValidation: 'PendingValidation',
  ServiceError: 'ServiceError'
};

exports.ActivityUserInputType = exports.$Enums.ActivityUserInputType = {
  Boolean: 'Boolean',
  Number: 'Number'
};

exports.WorkflowStatus = exports.$Enums.WorkflowStatus = {
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Paused: 'Paused',
  Error: 'Error',
  Completed: 'Completed',
  Canceled: 'Canceled'
};

exports.WorkflowManagerConfigType = exports.$Enums.WorkflowManagerConfigType = {
  ALLOW_ENVIRONMENT: 'ALLOW_ENVIRONMENT',
  ALLOW_STATE: 'ALLOW_STATE',
  ALLOW_STATE_REVISION: 'ALLOW_STATE_REVISION',
  ALLOW_FACILITY: 'ALLOW_FACILITY',
  ALLOW_FACILITY_REVISION: 'ALLOW_FACILITY_REVISION',
  DENY_TENANT: 'DENY_TENANT',
  DENY_TENANT_REVISION: 'DENY_TENANT_REVISION',
  DENY_FACILITY: 'DENY_FACILITY',
  DENY_FACILITY_REVISION: 'DENY_FACILITY_REVISION',
  STATE_BYPASS_VALIDATION: 'STATE_BYPASS_VALIDATION',
  FACILITY_BYPASS_VALIDATION: 'FACILITY_BYPASS_VALIDATION',
  FORCE_REPORT_TYPE_FOR_SUBMISSION: 'FORCE_REPORT_TYPE_FOR_SUBMISSION',
  TESTING_FAILURE_RATE: 'TESTING_FAILURE_RATE',
  WEB_AUTOMATION_STATE_OVERRIDE_USE_AA: 'WEB_AUTOMATION_STATE_OVERRIDE_USE_AA',
  DENY_LOB_MAIL_TO_SERC: 'DENY_LOB_MAIL_TO_SERC',
  VERSION: 'VERSION',
  SCHEDULER_WORK_INTERVAL_SLEEP_TIME_MS: 'SCHEDULER_WORK_INTERVAL_SLEEP_TIME_MS',
  SCHEDULER_CONSUMER_INTERVAL_SLEEP_TIME_MS: 'SCHEDULER_CONSUMER_INTERVAL_SLEEP_TIME_MS',
  SCHEDULER_RUNNING_POOL_MAX_CAPACITY: 'SCHEDULER_RUNNING_POOL_MAX_CAPACITY',
  SCHEDULER_DB_ACU_CUTOFF_PERCENT: 'SCHEDULER_DB_ACU_CUTOFF_PERCENT',
  SCHEDULER_ERROR_RATE_CUTOFF_PERCENT: 'SCHEDULER_ERROR_RATE_CUTOFF_PERCENT',
  SCHEDULER_CAPACITY_WAIT_DELAY_MS: 'SCHEDULER_CAPACITY_WAIT_DELAY_MS',
  SCHEDULER_LONG_RUNNING_THRESHOLD_MS: 'SCHEDULER_LONG_RUNNING_THRESHOLD_MS',
  SCHEDULER_METRICS_CACHE_DURATION_MS: 'SCHEDULER_METRICS_CACHE_DURATION_MS',
  SCHEDULER_LAMBDA_METRICS_WINDOW_MS: 'SCHEDULER_LAMBDA_METRICS_WINDOW_MS',
  SCHEDULER_MIN_ERROR_SAMPLES: 'SCHEDULER_MIN_ERROR_SAMPLES',
  SCHEDULER_COHORT_CLOSE_INTERVAL_MS: 'SCHEDULER_COHORT_CLOSE_INTERVAL_MS'
};

exports.Prisma.ModelName = {
  AiUsageTracking: 'AiUsageTracking',
  Audit: 'Audit',
  AuditedTable: 'AuditedTable',
  Chemical: 'Chemical',
  ChemicalComponent: 'ChemicalComponent',
  ChemicalDocument: 'ChemicalDocument',
  ChemicalMap: 'ChemicalMap',
  ChemicalStateField: 'ChemicalStateField',
  ChemicalTenant: 'ChemicalTenant',
  Cohort: 'Cohort',
  CohortMember: 'CohortMember',
  Comment: 'Comment',
  Communication: 'Communication',
  CommunicationDocument: 'CommunicationDocument',
  CommunicationFacility: 'CommunicationFacility',
  LobAddress: 'LobAddress',
  LobMail: 'LobMail',
  SendGridEmail: 'SendGridEmail',
  ComplianceQuarter: 'ComplianceQuarter',
  AlternateIdCredential: 'AlternateIdCredential',
  AlternateIdInfo: 'AlternateIdInfo',
  Credential: 'Credential',
  CredentialUsageLog: 'CredentialUsageLog',
  OneTimePassword: 'OneTimePassword',
  DataLedger: 'DataLedger',
  Document: 'Document',
  DocumentMetadata: 'DocumentMetadata',
  DocumentTag: 'DocumentTag',
  eManifestSiteSync: 'eManifestSiteSync',
  EmulatedRole: 'EmulatedRole',
  ErrorCluster: 'ErrorCluster',
  CalculatedRegulatoryStatus: 'CalculatedRegulatoryStatus',
  CalculationOperation: 'CalculationOperation',
  Facility: 'Facility',
  FacilityAlternateId: 'FacilityAlternateId',
  FacilityChemical: 'FacilityChemical',
  FacilityChemicalMeasurement: 'FacilityChemicalMeasurement',
  FacilityChemicalStateField: 'FacilityChemicalStateField',
  FacilityChemicalStorageLocation: 'FacilityChemicalStorageLocation',
  FacilityContact: 'FacilityContact',
  FacilityCredential: 'FacilityCredential',
  FacilityDocument: 'FacilityDocument',
  FacilityPayment: 'FacilityPayment',
  FacilityPilotProgram: 'FacilityPilotProgram',
  FacilityProduct: 'FacilityProduct',
  FacilityProductMeasurement: 'FacilityProductMeasurement',
  FacilityProductStorageLocation: 'FacilityProductStorageLocation',
  FacilityStateField: 'FacilityStateField',
  FacilityTag: 'FacilityTag',
  ProcessedManifest: 'ProcessedManifest',
  ReportingFacilityChemical: 'ReportingFacilityChemical',
  ReportingFacilityChemicalOrigin: 'ReportingFacilityChemicalOrigin',
  ReportingFacilityChemicalStorageLocation: 'ReportingFacilityChemicalStorageLocation',
  ReportingFacilityChemicalThresholdResult: 'ReportingFacilityChemicalThresholdResult',
  ThresholdResult: 'ThresholdResult',
  FireDepartment: 'FireDepartment',
  EchoAirFacility: 'EchoAirFacility',
  EchoAirViolationHistory: 'EchoAirViolationHistory',
  CaseEnforcements: 'CaseEnforcements',
  CasePrograms: 'CasePrograms',
  CaseEnforcementConclusions: 'CaseEnforcementConclusions',
  CaseEnforcementType: 'CaseEnforcementType',
  CasePriorities: 'CasePriorities',
  CasePollutants: 'CasePollutants',
  CaseLawSections: 'CaseLawSections',
  CaseViolations: 'CaseViolations',
  CaseEnforcementConclusionPollutants: 'CaseEnforcementConclusionPollutants',
  EpaInformalEnforcementActions: 'EpaInformalEnforcementActions',
  CasePenalties: 'CasePenalties',
  CaseFacilities: 'CaseFacilities',
  CaseDefendants: 'CaseDefendants',
  CaseRelatedActivities: 'CaseRelatedActivities',
  CaseEnforcementConclusionFacilities: 'CaseEnforcementConclusionFacilities',
  CaseEnforcementConclusionDollars: 'CaseEnforcementConclusionDollars',
  IcisFecEpaInspections: 'IcisFecEpaInspections',
  CaseRegionalDockets: 'CaseRegionalDockets',
  CaseReliefSought: 'CaseReliefSought',
  CaseEnforcementConclusionSep: 'CaseEnforcementConclusionSep',
  CaseEnforcementConclusionComplyingActions: 'CaseEnforcementConclusionComplyingActions',
  CaseMilestones: 'CaseMilestones',
  EchoExporter: 'EchoExporter',
  EchoFacilityMatchCandidate: 'EchoFacilityMatchCandidate',
  NpdesCsViolation: 'NpdesCsViolation',
  NpdesEffViolation: 'NpdesEffViolation',
  NpdesPsViolation: 'NpdesPsViolation',
  NpdesSeViolation: 'NpdesSeViolation',
  NpdesFacility: 'NpdesFacility',
  NpdesPermit: 'NpdesPermit',
  NpdesQncrHistory: 'NpdesQncrHistory',
  EchoRcraFacility: 'EchoRcraFacility',
  EchoRcraVioSncHistory: 'EchoRcraVioSncHistory',
  EchoRcraViolation: 'EchoRcraViolation',
  NationalContactFile: 'NationalContactFile',
  InsightsCohort: 'InsightsCohort',
  HdHandler: 'HdHandler',
  HdOwnerOperator: 'HdOwnerOperator',
  WasteLine: 'WasteLine',
  WasteLineTag: 'WasteLineTag',
  WasteManifest: 'WasteManifest',
  WasteTransporter: 'WasteTransporter',
  FacilityModelIssue: 'FacilityModelIssue',
  FacilityModelIssueCount: 'FacilityModelIssueCount',
  ModelIssue: 'ModelIssue',
  JobLog: 'JobLog',
  JobStepsDone: 'JobStepsDone',
  Job: 'Job',
  JobManagerConfig: 'JobManagerConfig',
  LeadAgency: 'LeadAgency',
  Lepc: 'Lepc',
  LinearWebhookEvent: 'LinearWebhookEvent',
  Lock: 'Lock',
  MergeRecord: 'MergeRecord',
  Notification: 'Notification',
  OneSchemaImport: 'OneSchemaImport',
  Payment: 'Payment',
  PaymentComment: 'PaymentComment',
  PaymentInvoice: 'PaymentInvoice',
  PaymentReconciliationHistory: 'PaymentReconciliationHistory',
  Person: 'Person',
  Pipeline: 'Pipeline',
  PoliceDepartment: 'PoliceDepartment',
  Portal: 'Portal',
  Product: 'Product',
  ProductChemical: 'ProductChemical',
  ProductChemicalOverride: 'ProductChemicalOverride',
  ProductTenant: 'ProductTenant',
  Role: 'Role',
  Snapshot: 'Snapshot',
  StorageLocation: 'StorageLocation',
  FacilitySubmission: 'FacilitySubmission',
  Submission: 'Submission',
  SubmissionDocument: 'SubmissionDocument',
  SubmissionDocumentReview: 'SubmissionDocumentReview',
  SubmissionPayment: 'SubmissionPayment',
  SubmissionReviewer: 'SubmissionReviewer',
  SubmissionTag: 'SubmissionTag',
  SupplementalFireDepartment: 'SupplementalFireDepartment',
  SupplementalLepc: 'SupplementalLepc',
  Tag: 'Tag',
  Task: 'Task',
  SubTask: 'SubTask',
  TaskTag: 'TaskTag',
  Tenant: 'Tenant',
  TenantConfig: 'TenantConfig',
  TenantContact: 'TenantContact',
  ReportFacilityDocument: 'ReportFacilityDocument',
  TierIIReport: 'TierIIReport',
  TierIIReportAssignee: 'TierIIReportAssignee',
  TierIIReportPayment: 'TierIIReportPayment',
  TierIIReportStatusLog: 'TierIIReportStatusLog',
  TierIIReportSubmissionMeasure: 'TierIIReportSubmissionMeasure',
  TierIIReportUstStatus: 'TierIIReportUstStatus',
  TierIIReportValidation: 'TierIIReportValidation',
  UndergroundStorageTank: 'UndergroundStorageTank',
  UndergroundStorageTankCertification: 'UndergroundStorageTankCertification',
  User: 'User',
  UserCalendarToken: 'UserCalendarToken',
  UserCognito: 'UserCognito',
  UserFacility: 'UserFacility',
  UserLogin: 'UserLogin',
  UserTenant: 'UserTenant',
  FacilityWasteStream: 'FacilityWasteStream',
  FacilityWasteStreamAmount: 'FacilityWasteStreamAmount',
  FacilityWasteStreamYearToDate: 'FacilityWasteStreamYearToDate',
  IngestSummary: 'IngestSummary',
  StateWasteCode: 'StateWasteCode',
  WasteLineUnified: 'WasteLineUnified',
  WasteLineUnifiedTag: 'WasteLineUnifiedTag',
  WasteManifestVendor: 'WasteManifestVendor',
  WasteStream: 'WasteStream',
  WasteStreamRaw: 'WasteStreamRaw',
  Activity: 'Activity',
  ActivityLog: 'ActivityLog',
  ActivityUserInput: 'ActivityUserInput',
  ActivityCohort: 'ActivityCohort',
  ActivityDocument: 'ActivityDocument',
  Workflow: 'Workflow',
  WorkflowManagerConfig: 'WorkflowManagerConfig',
  WorkflowTag: 'WorkflowTag',
  ZipCode: 'ZipCode',
  ChemicalAnomaly: 'ChemicalAnomaly',
  EchoExporterAggregated: 'EchoExporterAggregated',
  ProcessedManifestView: 'ProcessedManifestView',
  FacilityEPAIds: 'FacilityEPAIds',
  FacilityEchoExporter: 'FacilityEchoExporter',
  FacilityRCRAInfoExporter: 'FacilityRCRAInfoExporter',
  FacilityTierIIReport: 'FacilityTierIIReport',
  SnapshotReportingFacilityChemical: 'SnapshotReportingFacilityChemical',
  TierIIReportActivity: 'TierIIReportActivity'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
